(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/active-users-view/active-users-view.component.html":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/active-users-view/active-users-view.component.html ***!
  \**********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\t<mat-card class=\"transparent_card\" *ngIf=\"answered > 1\" >\n\t\t<p class=\"bigger_desc\">{{answered}} elever har svarat</p>\n\t</mat-card>\n\t<mat-card class=\"transparent_card\" *ngIf=\"answered == 1\" >\n\t\t<p class=\"bigger_desc\">{{answered}} elev har svarat</p>\n\t</mat-card>\n<!-- \t<mat-card class=\"transparent_card\">\n\t\t<p class=\"bigger_desc\">{{connected}} elever är anslutna till lektionen</p>\n\t</mat-card>\n\t<mat-card class=\"transparent_card\">\n\t\t<p class=\"bigger_desc\">Sessionens kod: <b>{{sessionCode}}</b></p>\n\t</mat-card> -->\n\n\n\t<div id=\"footer\">\n\t  <mat-card class=\"transparent_card\" style=\"z-index: 0;\">\n\t    <div class=\"session_image\"></div>\n\t    <p class=\"bigger_desc left_bottom_text\">Ange kod: <b>{{sessionCode}}</b></p>  \n\t    <p class=\"bigger_desc left_bottom_text\">levandehistoria.se/demo</p>\n\t  </mat-card>\n\n\n\t  <mat-card class=\"transparent_card\" style=\"z-index: 0;\">\n\t    <div class=\"connected_image\"></div>\n\t    <p class=\"bigger_desc right_bottom_text\">{{connected}}</p>\n\t  </mat-card>\n\t</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n<app-header></app-header>\n\n<!-- <div class=\"body_container\" >\n\t<app-text-view></app-text-view>\n</div> -->\n\n\n<!-- <div class=\"body_container\" >\n  <app-text-view (exitLast)=\"exitLast($event)\" (startHistorical)=\"startHistorical()\"></app-text-view>\n</div> -->\n\n\n\n<div *ngIf=\"!historicalStep && !lastQuestion\">\n\t<div class=\"body_container\" *ngIf=\"!isStudent && !isTeacher\" >\n\t  <app-top-info-block (selectedUser)=\"selectedUser($event)\"></app-top-info-block>\n\t</div>\n\n\t<div class=\"body_container\" *ngIf=\"isStudent && !studentSetup\" >\n\t  <app-student-view (startStudentQuiz)=\"startStudentQuiz()\" ></app-student-view>\n\t</div>\n\n\t<div class=\"body_container\" *ngIf=\"isStudent && studentSetup\" >\n\t  <app-student-quiz-view (startHistorical)=\"startHistorical()\" (exitHistorical)=\"exitHistorical($event)\" (stopStudentQuiz)=\"stopStudentQuiz()\"></app-student-quiz-view>\n\t</div>\n\n\t<div class=\"body_container\" *ngIf=\"isTeacher && !teacherSetup\" >\n\t  <app-teacher-config-view  (setTrack)=\"setTrack($event)\"></app-teacher-config-view>\n\t</div>\n\n\t<div class=\"body_container\" *ngIf=\"isTeacher && teacherSetup\" >\n\t  <app-teacher-quiz-view (startHistorical)=\"startHistorical()\" (resetAll)=\"resetAll()\"></app-teacher-quiz-view>\n\t</div>\n</div>\n\n<div class=\"body_container\" *ngIf=\"historicalStep\" >\n  <app-historical-view (exitHistorical)=\"exitHistorical($event)\" [isTeacher]=isTeacher></app-historical-view>\n</div>\n\n<div class=\"body_container\" *ngIf=\"teacherSetup || reseted\">\n  <app-active-users-view></app-active-users-view>\n</div>\n\n<div class=\"body_container\" *ngIf=\"lastQuestion\" >\n  <app-text-view (exitLast)=\"exitLast($event)\" (resetAll)=\"resetAll()\" (stopStudentQuiz)=\"stopStudentQuiz()\" (startHistorical)=\"startHistorical()\" [isTeacher]=isTeacher></app-text-view>\n</div>\n\n\n\n<!-- <div class=\"body_container\" *ngIf=\"isTeacher\">\n  <app-active-users-view></app-active-users-view>\n</div> -->\n\n\n<router-outlet></router-outlet>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/header/header.component.html":
/*!************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/header/header.component.html ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n<a href=\"https://levandehistoria.se\" style=\"position: absolute; top:0px;\"><div class=\"header_logo\"></div></a>\n<div style=\"margin-bottom: 80px;\"></div>\n\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/historical-view/historical-view.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/historical-view/historical-view.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div *ngIf=\"isTeacher\">\n\n\t<p (click)=\"previousQuestion()\" class=\"top_link_left\"><mat-icon aria-hidden=\"false\" class=\"arrow_icon_left\">keyboard_arrow_left</mat-icon>TILLBAKA TILL FÖRRA FRÅGAN</p>\n\n\t\t\n\t<p (click)=\"exitCases()\" class=\"top_link\">VIDARE TILL SISTA FRÅGAN<mat-icon aria-hidden=\"false\" class=\"arrow_icon_right\">keyboard_arrow_right</mat-icon>\n\t</p>\n</div>\n<div class=\"frontView\" *ngIf=!caseView>\n\n\n\t<!-- <mat-card class=\"transparent_card\" style=\"cursor: pointer;\" (click)=\"exitCases()\" *ngIf=\"isTeacher\">\n\t\t<mat-card-content>\n\t\t\t<h4>VIDARE TILL SISTA FRÅGAN <mat-icon aria-hidden=\"false\" class=\"arrow_icon_right\">keyboard_arrow_right</mat-icon></h4>\n\n\t\t</mat-card-content>\n\t</mat-card> -->\n\n\t<mat-card class=\"transparent_card\">\n\t\t<mat-card-content style=\"max-width: 600px;margin-left: auto;margin-right: auto;\">\n\t\t\t<h3>UPPGIFT: HISTORISKA CASE</h3>\n\t\t\t<button class=\"button_image\" mat-fab color=\"primary\" style=\"background-color: #7372A9;\">\n\t\t\t\t<span></span>\n\t\t\t</button>\n\t\t\t<p class=\"bigger_desc\">Fördjupa dig i dilemmafrågorna du just svarat på genom att läsa om historiska case där frågorna ställts på sin spets</p>\n\t\t\t<button mat-fab color=\"primary\" style=\"background-color: #7372A9; font-size: 38px;\">?\n\t\t\t</button>\n\t\t\t<p class=\"bigger_desc\">Fundera över ifall du tänker annorlunda i en fråga efter att du läst om det historiska caset? Varför? Varför inte?</p>\n\t\t\t<mat-divider class=\"divider\"></mat-divider>\n\t\t</mat-card-content>\n\t</mat-card>\n\n\t<mat-card class=\"transparent_card\" style=\"margin-bottom: 35px;\">\n\t\t<mat-card-content>\n\t\t\t<h3>VÄLJ ETT CASE</h3>\n\t\t</mat-card-content>\n\t</mat-card>\n\n\n\t<mat-card class=\"transparent_card\" (click)=\"openCase(1)\" style=\"cursor: pointer;\">\n\t\t<mat-card-content>\n\t\t\t<h4 class=\"caseTitle\">{{texts.part1.title | uppercase }}</h4>\n\t\t\t<img mat-card-image src='https://www.levandehistoria.se/demo/assets/images/track-{{track}}/1.png' style=\"max-width: 600px;\">\n\t\t</mat-card-content>\n\t</mat-card>\n\t<mat-card class=\"transparent_card\" (click)=\"openCase(2)\" style=\"cursor: pointer;\">\n\t\t<mat-card-content>\n\t\t\t<h4 class=\"caseTitle\">{{texts.part2.title | uppercase }}</h4>\n\t\t\t<img mat-card-image src='https://www.levandehistoria.se/demo/assets/images/track-{{track}}/2.png' style=\"max-width: 600px;\">\t\n\t\t</mat-card-content>\n\t</mat-card>\n<!-- \t<mat-card class=\"transparent_card\" (click)=\"openCase(3)\" style=\"cursor: pointer;\">\n\t\t<mat-card-content>\n\t\t\t<h4 class=\"caseTitle\">{{texts.part3.title | uppercase }}</h4>\n\t\t\t<img mat-card-image src='../../assets/images/track-{{track}}/3.png' style=\"max-width: 600px;\">\n\t\t</mat-card-content>\n\t</mat-card> -->\n\n\n</div>\n\n\n<div class=\"caseView\" *ngIf=caseView>\n\t\n\n\t<mat-card class=\"transparent_card case_view\" style=\"cursor: pointer;\" (click)=\"goBack()\">\n\t\t<mat-card-content>\n\t\t\t<h4 style=\"text-align: left;\"><mat-icon aria-hidden=\"false\" class=\"arrow_icon_left\" >keyboard_arrow_left</mat-icon>TILLBAKA TILL VÄLJA CASE</h4>\n\n\t\t</mat-card-content>\n\t</mat-card>\n\n\n\t<mat-card class=\"case_view\" style=\"color: black !important;\">\n\t\t<mat-card-content>\n\t\t\t<div style=\"position:relative;\">\n\t\t\t\t<img mat-card-image src='https://www.levandehistoria.se/demo/assets/images/track-{{track}}/{{case}}.png'>\n\t\t\t\t<div class=\"in-image\">{{currentImageText}}</div>\n\t\t\t</div>\n\t\t\t<h3 class=\"black_text\">{{currentTitle | uppercase}}</h3>\n\t\t\t<p style=\"margin-bottom: 5px;\">Lyssna på texten</p>\n\t\t\t\t<audio controls>\n\t\t\t\t\t<source src=\"https://www.levandehistoria.se/demo/assets/audio/track-{{track}}/{{case}}.mp3\" type=\"audio/mpeg\">\n\t\t\t\t</audio>\n\t\t\t<p [innerHTML]=\"currentText\" style=\"text-align: left;\"></p>\n\t\t\t<button (click)=\"showSourcesFunc()\" mat-flat-button class=\"black_button\">Visa källor <mat-icon aria-hidden=\"false\" class=\"\" >{{sourceArrow}}</mat-icon></button>\n\t\t</mat-card-content>\n\n\n\t\t<p style=\"text-align: left;\" *ngIf=\"showSources\" [innerHTML]=\"currentSource\"></p>\n\n\t</mat-card>\n\n\n\n\n\t<mat-card class=\"transparent_card statistic_question_box_green case_view\">\n\t\t<mat-card-content>\n\t\t\t<h1>{{quizQuestions[\"1\"] | uppercase}}</h1>\n\t\t</mat-card-content>\n\t</mat-card>\n\t<mat-card class=\"transparent_card statistic_question_box_black case_view\">\n\t\t<mat-card-content>\n\t\t\t<h1>SÅ HÄR SVARADE KLASSEN</h1>\n<!-- \t\t\t<h3>{{question_positive_1}} SVARADE JA</h3>\n\t\t\t<h3>{{question_negative_1}} SVARADE NEJ</h3> -->\n\n\t\t\t<google-chart style=\"margin-left: auto; margin-right: auto;\"\n\t\t\t\t[title]=\"title\"\n\t\t\t\t[type]=\"type\"\n\t\t\t\t[data]=\"data\"\n\t\t\t\t[columnNames]=\"columnNames\"\n\t\t\t\t[options]=\"options\">\n\t\t\t</google-chart>\n\n\t\t</mat-card-content>\n\t</mat-card>\n\t<mat-card class=\"transparent_card statistic_question_box_black case_view\" *ngIf=\"!isTeacher\">\n\t\t<mat-card-content>\n\t\t\t<h1 >DU SVARADE {{myAnswers[1] | uppercase }}</h1>\n\t\t</mat-card-content>\n\t</mat-card>\n\t<mat-card class=\"transparent_card statistic_question_pie_green case_view\">\n\t\t<mat-card-content>\n\t\t\t\n\t\t</mat-card-content>\n\t</mat-card>\n\n\t<mat-card class=\"transparent_card statistic_question_box_purple case_view\">\n\t\t<mat-card-content>\n\t\t\t<h1>{{quizQuestions[\"2\"] | uppercase}}</h1>\n\t\t</mat-card-content>\n\t</mat-card>\n\t<mat-card class=\"transparent_card statistic_question_box_black case_view\">\n\t\t<mat-card-content>\n\t\t\t<h1>SÅ HÄR SVARADE KLASSEN</h1>\n<!-- \t\t\t<h3>{{question_positive_2}} SVARADE JA</h3>\n\t\t\t<h3>{{question_negative_2}} SVARADE NEJ</h3> -->\n\t\t\t<google-chart style=\"margin-left: auto; margin-right: auto;\"\n\t\t\t\t[title]=\"title\"\n\t\t\t\t[type]=\"type\"\n\t\t\t\t[data]=\"data2\"\n\t\t\t\t[columnNames]=\"columnNames\"\n\t\t\t\t[options]=\"options2\">\n\t\t\t</google-chart>\n\t\t</mat-card-content>\n\t</mat-card>\n\t\t<mat-card class=\"transparent_card statistic_question_box_black case_view\" *ngIf=\"!isTeacher\">\n\t\t<mat-card-content>\n\t\t\t<h1>DU SVARADE {{myAnswers[2] | uppercase}}</h1>\n\t\t</mat-card-content>\n\t</mat-card>\n\t<mat-card class=\"transparent_card statistic_question_pie_purple case_view\">\n\t\t<mat-card-content>\n\t\t\t\n\t\t</mat-card-content>\n\t</mat-card>\n\n\t<mat-card class=\"transparent_card statistic_question_box_orange case_view\">\n\t\t<mat-card-content>\n\t\t\t<h1>{{quizQuestions[\"3\"] | uppercase}}</h1>\n\t\t</mat-card-content>\n\t</mat-card>\n\t<mat-card class=\"transparent_card statistic_question_box_black case_view\">\n\t\t<mat-card-content>\n\t\t\t<h1>SÅ HÄR SVARADE KLASSEN</h1>\n<!-- \t\t\t<h3>{{question_positive_3}} SVARADE JA</h3>\n\t\t\t<h3>{{question_negative_3}} SVARADE NEJ</h3> -->\n\t\t\t<google-chart style=\"margin-left: auto; margin-right: auto;\"\n\t\t\t\t[title]=\"title\"\n\t\t\t\t[type]=\"type\"\n\t\t\t\t[data]=\"data3\"\n\t\t\t\t[columnNames]=\"columnNames\"\n\t\t\t\t[options]=\"options3\">\n\t\t\t</google-chart>\n\t\t</mat-card-content>\n\t</mat-card>\n\t<mat-card class=\"transparent_card statistic_question_box_black case_view\" *ngIf=\"!isTeacher\">\n\t\t<mat-card-content>\n\t\t\t<h1>DU SVARADE {{myAnswers[3] | uppercase}}</h1>\n\t\t</mat-card-content>\n\t</mat-card>\n\t<mat-card class=\"transparent_card statistic_question_pie_orange case_view\">\n\t\t<mat-card-content>\n\t\t\t\n\t\t</mat-card-content>\n\t</mat-card>\n\t<mat-divider class=\"divider\"></mat-divider>\n\n\t<mat-card class=\"transparent_card case_view\" style=\"cursor: pointer;\" (click)=\"goBack()\">\n\t\t<mat-card-content>\n\t\t\t<h4 style=\"text-align: left;\"><mat-icon aria-hidden=\"false\" class=\"arrow_icon_left\">keyboard_arrow_left</mat-icon>TILLBAKA TILL VÄLJA CASE</h4>\n\n\t\t</mat-card-content>\n\t</mat-card>\n\n\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/student-quiz-view/student-quiz-view.component.html":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/student-quiz-view/student-quiz-view.component.html ***!
  \**********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-card class=\"transparent_card\">\n  <mat-card-content>\n    <h3>{{question | uppercase }}</h3>\n    <p class=\"bigger_desc\" *ngIf=showStatus>\n      {{description}}\n    </p>\n  </mat-card-content>\n</mat-card>\n\n<div *ngIf=!finalQuestion>\n\n  <mat-card class=\"transparent_card\" *ngIf=quizOn>\n\n    <button  class=\"timer\" mat-fab color=\"primary\" style=\"background-color: #4FB847;\" *ngIf=\"currentQuestion == 1\">\n    \t<countdown [config]=\"{leftTime: 20, demand: false, format: 's'}\" (event)=\"countDown($event)\"></countdown>\n    </button>\n     <button  class=\"timer\" mat-fab color=\"primary\" style=\"background-color: #7372A9;\" *ngIf=\"currentQuestion == 2\">\n      <countdown [config]=\"{leftTime: 20, demand: false, format: 's'}\" (event)=\"countDown($event)\"></countdown>\n    </button>\n     <button  class=\"timer\" mat-fab color=\"primary\" style=\"background-color: #F78F1E;\" *ngIf=\"currentQuestion == 3\">\n      <countdown [config]=\"{leftTime: 20, demand: false, format: 's'}\" (event)=\"countDown($event)\"></countdown>\n    </button>\n  </mat-card>\n\n<!--   <mat-card class=\"transparent_card\" *ngIf=!quizOn>\n    <button  class=\"timer\" mat-fab color=\"primary\" style=\"background-color: #4FB847;\" *ngIf=\"currentQuestion == 1\">\n    \t<countdown [config]=\"{leftTime: 20, demand: true, format: 's'}\"></countdown>\n    </button>\n    <button  class=\"timer\" mat-fab color=\"primary\" style=\"background-color: #7372A9;\" *ngIf=\"currentQuestion == 2\">\n      <countdown [config]=\"{leftTime: 20, demand: true, format: 's'}\"></countdown>\n    </button>\n    <button  class=\"timer\" mat-fab color=\"primary\" style=\"background-color: #F78F1E;\" *ngIf=\"currentQuestion == 3\">\n      <countdown [config]=\"{leftTime: 20, demand: true, format: 's'}\"></countdown>\n    </button>\n  </mat-card> -->\n\n  <!-- <mat-card class=\"transparent_card\" *ngIf=!quizOn>\n  \t<button mat-flat-button class=\"green_button no_margin\" color=\"primary\" style=\"width: 173px !important\" (click)=\"startQuestion()\">Ja</button>\n  \t<button mat-flat-button class=\"green_button no_margin\" color=\"primary\" style=\"width: 173px !important\" (click)=\"startQuestion()\">Nej</button>\n  </mat-card> -->\n\n  <mat-card class=\"transparent_card\" *ngIf=quizOn>\n  \t<button mat-flat-button class=\"green_button smaller\" color=\"primary\" style=\"margin-bottom: 20px;\" (click)=\"answer('ja')\">Ja</button>\n  \t<button mat-flat-button class=\"green_button smaller\" color=\"primary\" (click)=\"answer('nej')\">Nej</button>\n  </mat-card>\n\n\n  <mat-card class=\"transparent_card\" *ngIf=!quizOn>\n  \t<button mat-flat-button class=\"green_button smaller\" disabled color=\"primary\" style=\" opacity:0.6; margin-bottom: 20px;\">Ja</button>\n  \t<button mat-flat-button class=\"green_button smaller\" disabled color=\"primary\" style=\" opacity:0.6;\">Nej</button>\n  </mat-card>\n</div>\n\n<div *ngIf=finalQuestion>\n  <mat-card class=\"transparent_card\">\n    <mat-card-content>\n      <p class=\"bigger_desc\">{{description}}</p>\n\n    </mat-card-content>\n  </mat-card>\n\n  <mat-card class=\"transparent_card\">\n    <img mat-card-image src='https://www.levandehistoria.se/demo/assets/images/track-{{currentTrack}}/4.jpg' style=\"max-width: 600px;\">\n  </mat-card>\n  \n\n\n<!--   <mat-card class=\"transparent_card\">\n    <button mat-flat-button class=\"green_button no_margin\" color=\"primary\" style=\"width: 173px !important\" (click)=\"reset()\">Till lektionens startsida</button>\n  </mat-card> -->\n\n</div>\n\n\n\n\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/student-view/student-view.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/student-view/student-view.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-card class=\"transparent_card\">\n  <mat-card-content>\n    <h3>{{title}}</h3>\n    <p class=\"bigger_desc\">\n      {{description}}\n    </p>\n  </mat-card-content>\n\n<!-- <button mat-flat-button class=\"green_button\" color=\"primary\">Starta lektionen</button> -->\n</mat-card>\n\n<div *ngIf=!codeAccepted>\n<mat-card class=\"transparent_card\">\n\t<input ng-model=\"placeId\" class=\"text_field\" type=\"text\" placeholder=\"Fyll i kod\" (keyup)=\"OnInput($event)\" style=\"text-align: center; font-size: 16px;\">\n\n</mat-card>\n<mat-card class=\"transparent_card\">\n\t<button mat-flat-button class=\"green_button no_margin\" color=\"primary\" style=\"width: auto !important;\" (click)=\"checkCode()\">Starta lektionen</button>\n</mat-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/teacher-config-view/teacher-config-view.component.html":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/teacher-config-view/teacher-config-view.component.html ***!
  \**************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n<p *ngIf=\"codeSelected\" class=\"top_link_left\"><mat-icon aria-hidden=\"false\" class=\"arrow_icon_left\">keyboard_arrow_left</mat-icon><a style=\"text-decoration: none; color:white;\"  href=\"https://www.levandehistoria.se/demo\">Till lektionens startsida</a></p>\n\n\n<mat-card class=\"transparent_card center\">\n  <mat-card-content>\n    <h3>{{title}}</h3>\n    <p class=\"bigger_desc\" *ngIf=!codeSelected>\n      {{description}}\n    </p>\n  </mat-card-content>\n</mat-card>\n\n<div *ngIf=\"!codeSelected\" style=\"margin-bottom: 40px;\">\n\t<mat-card class=\"transparent_card\">\n\t\t<button mat-flat-button class=\"green_button\" color=\"primary\" (click)=\"selectedCodePath(1)\">Skapa ny kod</button>\n\t\t<button mat-flat-button class=\"green_button\" color=\"primary\" (click)=\"selectedCodePath(2)\">Ange en befintlig kod<span class=\"underText\">Om du vill fortsätta i en tidigare<br/> påbörjad lektion</span></button>\n\t</mat-card>\n</div>\n\n<div *ngIf=\"!codeSelected && usedCode && codePath\">\n\t<mat-card class=\"transparent_card center list\">\n\t\t<p class=\"bigger_desc_teacher\">1. Fyll i din kod här nedanför</p>\n\t</mat-card>\n\t<mat-card class=\"transparent_card center list\">\n\t\t<p class=\"bigger_desc_teacher\">2. Klicka på \"starta lektionen\"</p>\n\t</mat-card>\n<!-- \t<mat-card class=\"transparent_card center list\">\n\t\t<p class=\"bigger_desc_teacher\">3. Be eleverna klicka på \"elev\" på startsidan\noch sedan fylla i koden</p>\n\t</mat-card>\n\t<mat-card class=\"transparent_card center list\">\n\t\t<p class=\"bigger_desc_teacher\">3. Sedan är ni sammankopplade i en lektion!</p>\n\t</mat-card> -->\n\n\t<mat-card class=\"transparent_card\">\n\t\t<input ng-model=\"placeId\" class=\"text_field\" type=\"text\"  (input)=\"onSearchChange($event.target.value)\" placeholder=\"Fyll i kod\" style=\"text-align: center; font-size: 16px;\">\n\t</mat-card>\n\t<mat-card class=\"transparent_card\">\n\t\t<button mat-flat-button style=\"z-index: 999;\" class=\"green_button no_margin\" color=\"primary\" (click)=\"AcceptCode(1)\">Starta lektionen</button>\n\t</mat-card>\n\n</div>\n\n<div *ngIf=\"!codeSelected && !usedCode && codePath\">\n\n\n\t<mat-card class=\"transparent_card center list\">\n\t\t<p class=\"bigger_desc_teacher\">Varsågod, nere till vänster är din kod! Den kommer alltid finnas där under lektionen.</p>\n\t</mat-card>\n\t<mat-card class=\"transparent_card center list\">\n\t\t<p class=\"bigger_desc_teacher\">Spara, koden om du vill kunna återvända till lektionen vid senare tillfälle.</p>\n\t</mat-card>\n\t<mat-card class=\"transparent_card center list\">\n\t\t<p class=\"bigger_desc_teacher\">Klicka på starta lektionen för att koppla ihop dig med eleverna.</p>\n\t</mat-card>\n\n\n\t<mat-card class=\"transparent_card\">\n\n\t\t<!-- <input ng-model=\"placeId\" class=\"text_field\" type=\"text\" placeholder=\"Fyll i kod\" style=\"text-align: center; font-size: 16px;\" value=\"{{code}}\" disabled> -->\n\n\t</mat-card>\n\t<mat-card class=\"transparent_card\">\n\t\t<button mat-flat-button style=\"z-index: 999;\" class=\"green_button no_margin\" color=\"primary\" (click)=\"AcceptCode()\">Starta lektionen</button>\n\t</mat-card>\n</div>\n\n<div *ngIf=codeSelected>\n\n\n\t<div>\n\t\t<mat-card class=\"transparent_card center list\">\n\t\t\t<p class=\"bigger_desc_teacher\">1. Be eleverna gå till webbadressen nere till vänster och ange koden.</p>\n\t\t</mat-card>\n\t\t<mat-card class=\"transparent_card center list\">\n\t\t\t<p class=\"bigger_desc_teacher\">2. Välj tema att arbeta med. Sen är ni igång.</p>\n\t\t</mat-card>\n\n\n\t</div>\n\n\n\t<mat-card class=\"transparent_card\">\n\t\t<button mat-flat-button class=\"green_button no_margin wide\" color=\"primary\" (click)=\"SelectTrack(1)\">Tycka lika?</button>\n\t</mat-card>\n\t<mat-card class=\"transparent_card\">\n\t\t<button mat-flat-button class=\"green_button no_margin wide\" color=\"primary\" (click)=\"SelectTrack(2)\">Inflytande?</button>\n\t</mat-card>\n\t<mat-card class=\"transparent_card\">\n\t\t<button mat-flat-button class=\"green_button no_margin wide\" color=\"primary\" (click)=\"SelectTrack(3)\">Samma möjligheter?</button>\n\t</mat-card>\n\n</div>\n\n<div *ngIf=\"!usedCode && codePath \">\n\n\n\t<div id=\"footer\">\n\t  <mat-card class=\"transparent_card\" style=\"z-index: 0;\">\n\t    <div class=\"session_image\"></div>\n\t    <p class=\"bigger_desc left_bottom_text\">Ange kod: <b>{{sessionCode}}</b></p>  \n\t    <p class=\"bigger_desc left_bottom_text\">levandehistoria.se/demo</p>\n\t  </mat-card>\n\n\n\t  <mat-card class=\"transparent_card\" style=\"z-index: 0;\">\n\t    <div class=\"connected_image\"></div>\n\t    <p class=\"bigger_desc right_bottom_text\">{{connected}}</p>\n\t  </mat-card>\n\t</div>\t\t\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/teacher-quiz-view/teacher-quiz-view.component.html":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/teacher-quiz-view/teacher-quiz-view.component.html ***!
  \**********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p *ngIf=\"currentQuestion != 1\" (click)=\"previousQuestion()\" class=\"top_link_left\"><mat-icon aria-hidden=\"false\" class=\"arrow_icon_left\">keyboard_arrow_left</mat-icon>{{previous_arrow_text | uppercase }}</p>\n\n<p *ngIf=\"currentQuestion == 1\" (click)=\"reset()\" class=\"top_link_left\"><mat-icon aria-hidden=\"false\" class=\"arrow_icon_left\">keyboard_arrow_left</mat-icon>Välja tema</p>\n\n<p *ngIf=\"!finalQuestion\" (click)=\"nextQuestion()\" class=\"top_link\">{{next_arrow_text | uppercase }}<mat-icon aria-hidden=\"false\" class=\"arrow_icon_right\">keyboard_arrow_right</mat-icon></p>\n\n\n\n<mat-card class=\"transparent_card\">\n  <mat-card-content>\n    <h3>{{question | uppercase }}</h3>\n    <p class=\"bigger_desc\" *ngIf=!codeSelected>\n      <!-- {{description}} -->\n    </p>\n  </mat-card-content>\n</mat-card>\n\n\n<div *ngIf=\"!finalQuestion\">\n  <div *ngIf=!showResult>\n  <mat-card class=\"transparent_card\" *ngIf=quizOn>\n    <button class=\"timer\" mat-fab color=\"primary\" style=\"background-color: #4FB847;\" *ngIf=\"currentQuestion == 1\">\n    \t<countdown [config]=\"{leftTime: 20, demand: false, format: 's'}\" (event)=\"countDown($event)\"></countdown>\n    </button>\n    <button class=\"timer\" mat-fab color=\"primary\" style=\"background-color: #7372A9;\" *ngIf=\"currentQuestion == 2\">\n      <countdown [config]=\"{leftTime: 20, demand: false, format: 's'}\" (event)=\"countDown($event)\"></countdown>\n    </button>\n    <button class=\"timer\" mat-fab color=\"primary\" style=\"background-color: #F78F1E;\" *ngIf=\"currentQuestion == 3\">\n      <countdown [config]=\"{leftTime: 20, demand: false, format: 's'}\" (event)=\"countDown($event)\"></countdown>\n    </button>\n    <button class=\"timer\" mat-fab color=\"primary\" style=\"background-color: #7372A9;\" *ngIf=\"currentQuestion > 3\">\n      <countdown [config]=\"{leftTime: 20, demand: false, format: 's'}\" (event)=\"countDown($event)\"></countdown>\n    </button>\n  </mat-card>\n\n</div>\n\n\n  <mat-card class=\"transparent_card\" *ngIf=!quizOn>\n  \t<button mat-flat-button class=\"green_button no_margin\" color=\"primary\" style=\"width: 173px !important\" (click)=\"startQuestion()\">Starta fråga</button>\n  </mat-card>\n\n\n  <mat-card class=\"transparent_card\" style=\"margin-top: -100px !important;\" *ngIf=showResult>\n    <mat-card-content>\n      <google-chart style=\"margin-left: auto; margin-right: auto;\" *ngIf=\"currentQuestion == 1\"\n        [title]=\"title\"\n        [type]=\"type\"\n        [data]=\"data\"\n        [columnNames]=\"columnNames\"\n        [options]=\"options\"\n        [width]=\"width\"\n        [height]=\"height\">\n      </google-chart>\n      <google-chart style=\"margin-left: auto; margin-right: auto;\" *ngIf=\"currentQuestion == 2\"\n        [title]=\"title\"\n        [type]=\"type\"\n        [data]=\"data\"\n        [columnNames]=\"columnNames\"\n        [options]=\"options2\"\n        [width]=\"width\"\n        [height]=\"height\">\n      </google-chart>\n      <google-chart style=\"margin-left: auto; margin-right: auto;\" *ngIf=\"currentQuestion == 3\"\n        [title]=\"title\"\n        [type]=\"type\"\n        [data]=\"data\"\n        [columnNames]=\"columnNames\"\n        [options]=\"options3\"\n        [width]=\"width\"\n        [height]=\"height\">\n      </google-chart>\n      <google-chart style=\"margin-left: auto; margin-right: auto;\" *ngIf=\"currentQuestion > 3\"\n        [title]=\"title\"\n        [type]=\"type\"\n        [data]=\"data\"\n        [columnNames]=\"columnNames\"\n        [options]=\"options2\"\n        [width]=\"width\"\n        [height]=\"height\">\n      </google-chart>\n    </mat-card-content>\n  </mat-card>\n\n  <mat-card class=\"transparent_card\" *ngIf=timesUp>\n  \t<button mat-flat-button class=\"green_button no_margin\" color=\"primary\" (click)=\"presentResult()\">Visa klassens svar</button>\n  </mat-card>\n\n\n\n  <mat-card class=\"transparent_card\" *ngIf=\"showResult\" style=\"margin-top: -100px !important\">\n\n  \t<button mat-flat-button class=\"green_button no_margin\" color=\"primary\" (click)=\"nextQuestion()\">{{next_text}}</button>\n\n  </mat-card>\n\n\n\n\n  \n</div>\n\n<div *ngIf=\"quizOn\">\n  \n  <audio controls autoplay style=\"display: none;\">\n    <source  src=\"https://www.levandehistoria.se/demo/assets/audio/Countdown.mp3\" type=\"audio/mpeg\">\n  </audio>\n\n</div>\n\n\n<div *ngIf=finalQuestion>\n\n\n  <mat-card class=\"transparent_card\">\n    <mat-card-content>\n      <p class=\"bigger_desc\">{{description}}</p>\n\n    </mat-card-content>\n  </mat-card>\n\n  <mat-card class=\"transparent_card\">\n    <img mat-card-image src='../../assets/images/track-{{currentTrack}}/4.jpg' style=\"max-width: 600px;\">\n  </mat-card>\n\n\n\n  <mat-card class=\"transparent_card\">\n    <button mat-flat-button class=\"green_button no_margin\" color=\"primary\" style=\"width: auto !important\" (click)=\"reset()\">Till lektionens startsida</button>\n  </mat-card>\n</div>\n\n\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/text-view/text-view.component.html":
/*!******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/text-view/text-view.component.html ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p *ngIf=\"isTeacher\" (click)=\"previousQuestion()\" class=\"top_link_left\"><mat-icon aria-hidden=\"false\" class=\"arrow_icon_left\">keyboard_arrow_left</mat-icon>TILLBAKA TILL HISTORISKA CASE</p>\n\n<p *ngIf=\"isTeacher\" (click)=\"reset()\" class=\"top_link\"><mat-icon aria-hidden=\"false\" class=\"arrow_icon_left\">keyboard_arrow_left</mat-icon>Välj nytt tema</p>\n\n\n\n\n\n<mat-card class=\"transparent_card\">\n  <mat-card-content>\n    <!-- <h3>{{question | uppercase }}</h3> -->\n    <h3>{{question | uppercase}}</h3>\n    <p class=\"bigger_desc\" *ngIf=showStatus>\n      Beskrivning\n    </p>\n  </mat-card-content>\n</mat-card>\n\n\n<div class=\"parent\" *ngIf=isTeacher>\n  <div *ngFor=\"let answer of allAnswers; let i = index\" class=\"child {{getColor(i)}}\">{{answer.answer}}</div>\n</div>\n\n\n\n<mat-card class=\"transparent_card\" *ngIf=!isTeacher>\n\n\t<div *ngIf=!answered>\n\t\t<textarea rows=\"10\" cols=\"40\" ng-model=\"placeId\" class=\"textarea\" type=\"text\" placeholder=\"Fyll i ditt svar\" (keyup)=\"OnInput($event)\" style=\"text-align: center; resize: none; width:100% !important;\" maxlength=\"230\"></textarea>\n\t\t<p class=\"bigger_desc\" style=\"margin: 0px !important;\"> {{totalChars}}/230 </p>\n\t\t<mat-card class=\"transparent_card\">\n\t\t\t<button mat-flat-button class=\"green_button no_margin\" color=\"primary\" style=\"width: auto !important;\" (click)=\"sendAnswer()\">Skicka svar</button>\n\t\t\t\n\t\t</mat-card>\n\t</div>\n\n\t<div *ngIf=answered>\n\t\t<p class=\"bigger_desc\">\n\t  \t\tDitt svar är skickat! <br>\n\t  \t\tDu kan se ditt svar på lärarens skärm!\n\t    </p>\t\n\t</div>\n\t\n</mat-card>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/top-info-block/top-info-block.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/top-info-block/top-info-block.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p  class=\"top_link_left\"><mat-icon aria-hidden=\"false\" class=\"arrow_icon_left\">keyboard_arrow_left</mat-icon><a style=\"text-decoration: none; color:white;\"  href=\"https://www.levandehistoria.se/node/5070\">Tillbaka till Lärarrummet</a></p>\n\n\n\n<mat-card class=\"transparent_card center \">\n  <mat-card-content>\n    <h3>DEMOKRATISKA SAMTAL</h3>\n    <p class=\"bigger_desc\">\n      För att en demokrati ska fungera behöver allt kunna pratas om. Men det kan vara svårt. I den här lektionen kommer du få tycka till om hur det funkar. Och hur du tycker att det borde funka.\n    </p>\n  </mat-card-content>\n</mat-card>\n<mat-card class=\"transparent_card center\">\n  <mat-card-content>\n    <mat-divider class=\"divider\"></mat-divider>\n  </mat-card-content>\n</mat-card>\n\n<mat-card class=\"transparent_card\">\n  <mat-card-content>\n    <h3>STARTA LEKTIONEN SOM</h3>\n    <button style=\"margin-bottom: 20px;\" mat-flat-button class=\"green_button_static smaller\" color=\"primary\" (click)='userChoice(\"student\")'>Elev</button>\n    <button mat-flat-button class=\"green_button_static smaller\" color=\"primary\" (click)='userChoice(\"teacher\")'>Lärare</button>\n  </mat-card-content>\n</mat-card>\n\n\n<mat-card class=\"transparent_card center\">\n  <mat-card-content>\n\n\n  </mat-card-content>\n</mat-card>\n\n<!-- <div class=\"parent\">\n  <div *ngFor=\"let answer of allAnswers; let i = index\" class=\"child {{getColor(i)}}\">{{answer.answer}}</div>\n</div> -->");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/active-users-view/active-users-view.component.css":
/*!*******************************************************************!*\
  !*** ./src/app/active-users-view/active-users-view.component.css ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FjdGl2ZS11c2Vycy12aWV3L2FjdGl2ZS11c2Vycy12aWV3LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/active-users-view/active-users-view.component.ts":
/*!******************************************************************!*\
  !*** ./src/app/active-users-view/active-users-view.component.ts ***!
  \******************************************************************/
/*! exports provided: ActiveUsersViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActiveUsersViewComponent", function() { return ActiveUsersViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/api-caller.service */ "./src/app/services/api-caller.service.ts");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angularfire2/database */ "./node_modules/angularfire2/database/index.js");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(angularfire2_database__WEBPACK_IMPORTED_MODULE_3__);




let ActiveUsersViewComponent = class ActiveUsersViewComponent {
    constructor(service, db) {
        this.service = service;
        this.db = db;
        this.connected = 0;
        this.totalConnects = 0;
        this.totalDisConnects = 0;
        this.answered = 0;
        this.sessionCode = "";
    }
    calculateConnects() {
        this.connected = this.totalConnects - this.totalDisConnects;
    }
    ngOnInit() {
        this.sessionCode = this.service.sessionCode;
        this.db.list('/Session-' + this.service.sessionCode + "/connected").valueChanges().subscribe((session) => {
            this.totalConnects = session.length;
            this.calculateConnects();
        });
        this.db.list('/Session-' + this.service.sessionCode + "/disconnected").valueChanges().subscribe((disconnects) => {
            this.totalDisConnects = disconnects.length;
            this.calculateConnects();
        });
        this.db.list('/Session-' + this.service.sessionCode + "/currentAnswer").valueChanges().subscribe((totalAnswers) => {
            this.answered = totalAnswers.length;
        });
    }
};
ActiveUsersViewComponent.ctorParameters = () => [
    { type: _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__["ApiCallerService"] },
    { type: angularfire2_database__WEBPACK_IMPORTED_MODULE_3__["AngularFireDatabase"] }
];
ActiveUsersViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-active-users-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./active-users-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/active-users-view/active-users-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./active-users-view.component.css */ "./src/app/active-users-view/active-users-view.component.css")).default]
    })
], ActiveUsersViewComponent);



/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



const routes = [];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\r\n:host {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\r\n  font-size: 14px;\r\n  color: #333;\r\n  box-sizing: border-box;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\nbody{\r\n  background-color: green !important;\r\n  color: red !important;\r\n}\r\n\r\nh3{\r\n    font-size: 42px !important;\r\n    line-height: 45px !important;\r\n}\r\n\r\np{\r\n  font-size: 16px;\r\n}\r\n\r\n.black_text {\r\n\tcolor: black !important;\r\n}\r\n\r\n.white_text {\r\n\tcolor: white !important;\r\n}\r\n\r\n/* Responsive Styles */\r\n\r\n@media screen and (max-width: 767px) {\r\n\r\n\r\n  }\r\n\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvYXBwLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUNBO0VBQ0UsMEpBQTBKO0VBQzFKLGVBQWU7RUFDZixXQUFXO0VBQ1gsc0JBQXNCO0VBQ3RCLG1DQUFtQztFQUNuQyxrQ0FBa0M7QUFDcEM7O0FBRUE7RUFDRSxrQ0FBa0M7RUFDbEMscUJBQXFCO0FBQ3ZCOztBQUdBO0lBQ0ksMEJBQTBCO0lBQzFCLDRCQUE0QjtBQUNoQzs7QUFFQTtFQUNFLGVBQWU7QUFDakI7O0FBR0E7Q0FDQyx1QkFBdUI7QUFDeEI7O0FBQ0E7Q0FDQyx1QkFBdUI7QUFDeEI7O0FBR0Usc0JBQXNCOztBQUN0Qjs7O0VBR0EiLCJmaWxlIjoic3JjL2FwcC9hcHAuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIlxyXG46aG9zdCB7XHJcbiAgZm9udC1mYW1pbHk6IC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgXCJTZWdvZSBVSVwiLCBSb2JvdG8sIEhlbHZldGljYSwgQXJpYWwsIHNhbnMtc2VyaWYsIFwiQXBwbGUgQ29sb3IgRW1vamlcIiwgXCJTZWdvZSBVSSBFbW9qaVwiLCBcIlNlZ29lIFVJIFN5bWJvbFwiO1xyXG4gIGZvbnQtc2l6ZTogMTRweDtcclxuICBjb2xvcjogIzMzMztcclxuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xyXG4gIC13ZWJraXQtZm9udC1zbW9vdGhpbmc6IGFudGlhbGlhc2VkO1xyXG4gIC1tb3otb3N4LWZvbnQtc21vb3RoaW5nOiBncmF5c2NhbGU7XHJcbn1cclxuXHJcbmJvZHl7XHJcbiAgYmFja2dyb3VuZC1jb2xvcjogZ3JlZW4gIWltcG9ydGFudDtcclxuICBjb2xvcjogcmVkICFpbXBvcnRhbnQ7XHJcbn1cclxuXHJcblxyXG5oM3tcclxuICAgIGZvbnQtc2l6ZTogNDJweCAhaW1wb3J0YW50O1xyXG4gICAgbGluZS1oZWlnaHQ6IDQ1cHggIWltcG9ydGFudDtcclxufVxyXG5cclxucHtcclxuICBmb250LXNpemU6IDE2cHg7XHJcbn1cclxuXHJcblxyXG4uYmxhY2tfdGV4dCB7XHJcblx0Y29sb3I6IGJsYWNrICFpbXBvcnRhbnQ7XHJcbn1cclxuLndoaXRlX3RleHQge1xyXG5cdGNvbG9yOiB3aGl0ZSAhaW1wb3J0YW50O1xyXG59XHJcblxyXG5cclxuICAvKiBSZXNwb25zaXZlIFN0eWxlcyAqL1xyXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDc2N3B4KSB7XHJcblxyXG5cclxuICB9XHJcblxyXG4iXX0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: Answers, AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Answers", function() { return Answers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./services/api-caller.service */ "./src/app/services/api-caller.service.ts");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angularfire2/database */ "./node_modules/angularfire2/database/index.js");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(angularfire2_database__WEBPACK_IMPORTED_MODULE_3__);




class Answers {
}
let AppComponent = class AppComponent {
    constructor(service, db) {
        this.service = service;
        this.db = db;
        this.number = "";
        this.testing = [];
        this.teacherSetup = false;
        this.studentSetup = false;
        this.isTeacher = false;
        this.isStudent = false;
        this.historicalStep = false;
        this.sessionCreated = false;
        this.lastQuestion = false;
        this.reseted = false;
    }
    selectedUser(event) {
        if (event == "student") {
            this.isStudent = true;
        }
        else {
            this.isTeacher = true;
        }
    }
    setTrack(event) {
        this.teacherSetup = true;
        this.service.selectedTrack = event;
        this.service.currentQuestion = 1;
    }
    startStudentQuiz() {
        this.studentSetup = true;
    }
    stopStudentQuiz() {
        this.studentSetup = false;
    }
    startHistorical() {
        this.historicalStep = true;
        this.lastQuestion = false;
    }
    exitHistorical(event) {
        if (event == 1) {
            this.lastQuestion = true;
        }
        this.historicalStep = false;
    }
    exitLast() {
        this.historicalStep = true;
        this.lastQuestion = false;
    }
    resetAll() {
        console.log("Resetted?!");
        this.teacherSetup = false;
        this.studentSetup = false;
        this.isTeacher = true;
        this.isStudent = false;
        this.historicalStep = false;
        this.sessionCreated = true;
        this.service.saveCode = true;
        this.lastQuestion = false;
        if (this.service.saveCode) {
            this.reseted = true;
        }
    }
    ngOnInit() {
        // this.db.list('/Session-815275/connected').remove("student");
        // this.db.list('/Session-815275/active').push(1);
    }
    ngOnDestroy() {
    }
};
AppComponent.ctorParameters = () => [
    { type: _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__["ApiCallerService"] },
    { type: angularfire2_database__WEBPACK_IMPORTED_MODULE_3__["AngularFireDatabase"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/button */ "./node_modules/@angular/material/esm2015/button.js");
/* harmony import */ var _angular_material_divider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/divider */ "./node_modules/@angular/material/esm2015/divider.js");
/* harmony import */ var _angular_material_card__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/card */ "./node_modules/@angular/material/esm2015/card.js");
/* harmony import */ var _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/toolbar */ "./node_modules/@angular/material/esm2015/toolbar.js");
/* harmony import */ var _angular_material_input__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/input */ "./node_modules/@angular/material/esm2015/input.js");
/* harmony import */ var _angular_material_slider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material/slider */ "./node_modules/@angular/material/esm2015/slider.js");
/* harmony import */ var _header_header_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./header/header.component */ "./src/app/header/header.component.ts");
/* harmony import */ var _top_info_block_top_info_block_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./top-info-block/top-info-block.component */ "./src/app/top-info-block/top-info-block.component.ts");
/* harmony import */ var _student_view_student_view_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./student-view/student-view.component */ "./src/app/student-view/student-view.component.ts");
/* harmony import */ var _teacher_config_view_teacher_config_view_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./teacher-config-view/teacher-config-view.component */ "./src/app/teacher-config-view/teacher-config-view.component.ts");
/* harmony import */ var _angular_material_list__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @angular/material/list */ "./node_modules/@angular/material/esm2015/list.js");
/* harmony import */ var _angular_material_icon__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @angular/material/icon */ "./node_modules/@angular/material/esm2015/icon.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var angularfire2__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! angularfire2 */ "./node_modules/angularfire2/index.js");
/* harmony import */ var angularfire2__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(angularfire2__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! angularfire2/database */ "./node_modules/angularfire2/database/index.js");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(angularfire2_database__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _teacher_quiz_view_teacher_quiz_view_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./teacher-quiz-view/teacher-quiz-view.component */ "./src/app/teacher-quiz-view/teacher-quiz-view.component.ts");
/* harmony import */ var ngx_countdown__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ngx-countdown */ "./node_modules/ngx-countdown/fesm2015/ngx-countdown.js");
/* harmony import */ var _student_quiz_view_student_quiz_view_component__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./student-quiz-view/student-quiz-view.component */ "./src/app/student-quiz-view/student-quiz-view.component.ts");
/* harmony import */ var _historical_view_historical_view_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./historical-view/historical-view.component */ "./src/app/historical-view/historical-view.component.ts");
/* harmony import */ var _active_users_view_active_users_view_component__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./active-users-view/active-users-view.component */ "./src/app/active-users-view/active-users-view.component.ts");
/* harmony import */ var angular_google_charts__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! angular-google-charts */ "./node_modules/angular-google-charts/fesm2015/angular-google-charts.js");
/* harmony import */ var _text_view_text_view_component__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./text-view/text-view.component */ "./src/app/text-view/text-view.component.ts");
/* harmony import */ var firebase_analytics__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! firebase/analytics */ "./node_modules/firebase/analytics/dist/index.esm.js");






























let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"],
            _header_header_component__WEBPACK_IMPORTED_MODULE_13__["HeaderComponent"],
            _top_info_block_top_info_block_component__WEBPACK_IMPORTED_MODULE_14__["TopInfoBlockComponent"],
            _student_view_student_view_component__WEBPACK_IMPORTED_MODULE_15__["StudentViewComponent"],
            _teacher_config_view_teacher_config_view_component__WEBPACK_IMPORTED_MODULE_16__["TeacherConfigViewComponent"],
            _teacher_quiz_view_teacher_quiz_view_component__WEBPACK_IMPORTED_MODULE_22__["TeacherQuizViewComponent"],
            _student_quiz_view_student_quiz_view_component__WEBPACK_IMPORTED_MODULE_24__["StudentQuizViewComponent"],
            _historical_view_historical_view_component__WEBPACK_IMPORTED_MODULE_25__["HistoricalViewComponent"],
            _active_users_view_active_users_view_component__WEBPACK_IMPORTED_MODULE_26__["ActiveUsersViewComponent"],
            _text_view_text_view_component__WEBPACK_IMPORTED_MODULE_28__["TextViewComponent"],
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_4__["AppRoutingModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_6__["BrowserAnimationsModule"],
            _angular_material_button__WEBPACK_IMPORTED_MODULE_7__["MatButtonModule"],
            _angular_material_divider__WEBPACK_IMPORTED_MODULE_8__["MatDividerModule"],
            _angular_material_card__WEBPACK_IMPORTED_MODULE_9__["MatCardModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_11__["MatInputModule"],
            _angular_material_list__WEBPACK_IMPORTED_MODULE_17__["MatListModule"],
            _angular_material_icon__WEBPACK_IMPORTED_MODULE_18__["MatIconModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_19__["HttpClientModule"],
            angularfire2__WEBPACK_IMPORTED_MODULE_20__["AngularFireModule"].initializeApp(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].firebase),
            angularfire2_database__WEBPACK_IMPORTED_MODULE_21__["AngularFireDatabaseModule"],
            ngx_countdown__WEBPACK_IMPORTED_MODULE_23__["CountdownModule"],
            _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_10__["MatToolbarModule"],
            _angular_material_slider__WEBPACK_IMPORTED_MODULE_12__["MatSliderModule"],
            angular_google_charts__WEBPACK_IMPORTED_MODULE_27__["GoogleChartsModule"]
        ],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/header/header.component.css":
/*!*********************************************!*\
  !*** ./src/app/header/header.component.css ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2hlYWRlci9oZWFkZXIuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/header/header.component.ts":
/*!********************************************!*\
  !*** ./src/app/header/header.component.ts ***!
  \********************************************/
/*! exports provided: HeaderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderComponent", function() { return HeaderComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HeaderComponent = class HeaderComponent {
    constructor() { }
    ngOnInit() {
    }
};
HeaderComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-header',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./header.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/header/header.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./header.component.css */ "./src/app/header/header.component.css")).default]
    })
], HeaderComponent);



/***/ }),

/***/ "./src/app/historical-view/historical-view.component.css":
/*!***************************************************************!*\
  !*** ./src/app/historical-view/historical-view.component.css ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".black_text {\r\n\tcolor: black;\r\n}\r\n.button_image{\r\n\t\tbackground-image: url(\"https://www.levandehistoria.se/demo/assets/images/fundera.png\");\r\n\t\tbackground-repeat: no-repeat;\r\n\t\tbackground-size: cover;\r\n/*\t\theight: 56px;\r\n\t\twidth: 60px;\r\n\t\tbackground-size: 100% 100%;\r\n\t\tmargin-left: 15px;\r\n\t\tmargin-top: 9px;*/\r\n}\r\n.statistic_question_box_green{\r\n\tbackground-color: #4FB847;\r\n    margin-top: 75px;\r\n}\r\n.statistic_question_box_purple{\r\n\tbackground-color: #7372A9;\r\n    margin-top: 75px;\r\n}\r\n.statistic_question_box_orange{\r\n\tbackground-color: #F78F1E;\r\n    margin-top: 75px;\r\n}\r\n.arrow_icon_left{\r\n\tposition: absolute;\r\n\tmargin-left: -31px;\r\n\tmargin-top: -6px;\r\n\tfont-size: 35px;\r\n}\r\n.arrow_icon_right{\r\n\tposition: absolute;\r\n\tmargin-top: -6px;\r\n\tfont-size: 35px;\r\n}\r\n.case_view{\r\n\tmargin-left: auto;\r\n\tmargin-right: auto;\r\n\tmax-width: 600px;\r\n}\r\n.center{\r\n\tmax-width: 400px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n.black_button{\r\n\tbackground-color: #000000;\r\n\tcolor: #FFFFFF;\r\n}\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/historical-view/historical-view.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/historical-view/historical-view.component.ts ***!
  \**************************************************************/
/*! exports provided: HistoricalViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HistoricalViewComponent", function() { return HistoricalViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/api-caller.service */ "./src/app/services/api-caller.service.ts");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angularfire2/database */ "./node_modules/angularfire2/database/index.js");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(angularfire2_database__WEBPACK_IMPORTED_MODULE_3__);




let HistoricalViewComponent = class HistoricalViewComponent {
    constructor(service, db) {
        this.service = service;
        this.db = db;
        this.exitHistorical = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.data = [
            ['JA', 0],
            ['NEJ', 0]
        ];
        this.data2 = [
            ['JA', 0],
            ['NEJ', 0]
        ];
        this.data3 = [
            ['JA', 0],
            ['NEJ', 0]
        ];
        this.type = 'PieChart';
        this.options = {
            id: "chart1",
            colors: ['#6CAEDF', '#4FB847'],
            height: 400,
            backgroundColor: "transparent",
            legend: 'none',
            pieSliceText: 'label',
            tooltip: { textStyle: { fontSize: 14, bold: true } }
        };
        this.options2 = {
            id: "chart2",
            colors: ['#6CAEDF', '#7372A9'],
            height: 400,
            backgroundColor: "transparent",
            legend: 'none',
            pieSliceText: 'label',
            tooltip: { textStyle: { fontSize: 14, bold: true } }
        };
        this.options3 = {
            id: "chart3",
            colors: ['#EF4E91', '#F78F1E'],
            height: 400,
            backgroundColor: "transparent",
            legend: 'none',
            pieSliceText: 'label',
            tooltip: { textStyle: { fontSize: 14, bold: true } }
        };
        this.question_positive_1 = 0;
        this.question_positive_2 = 0;
        this.question_positive_3 = 0;
        this.question_negative_1 = 0;
        this.question_negative_2 = 0;
        this.question_negative_3 = 0;
        this.myAnswers = [];
        this.users = 0;
        this.caseView = false;
        this.showSources = false;
        this.track = 0;
        this.case = 1;
        this.currentTitle = "";
        this.currentText = "";
        this.currentSource = "";
        this.currentImageText = "";
        this.sourceArrow = "keyboard_arrow_down";
    }
    beforeUnloadHander(event) {
        if (!this.isTeacher) { }
        this.db.list('/Session-' + this.service.sessionId + "/disconnected").push("1");
    }
    ngOnDestroy() {
        if (!this.isTeacher)
            this.actionSub.unsubscribe();
    }
    ngOnInit() {
        // this.service.sessionId = "342216";
        // this.service.selectedTrack = 1;
        this.myAnswers = this.service.myAnswers;
        if (!this.isTeacher) {
            this.actionSub = this.db.list('/Session-' + this.service.sessionId + "/action").valueChanges().subscribe((action) => {
                if (action.length == 0) {
                    return;
                }
                if (action == "text") {
                    this.service.currentQuestion = 3;
                    this.exitHistorical.emit(1);
                }
                else if (action == "previous") {
                    this.service.currentQuestion = 4;
                    this.exitHistorical.emit(0);
                }
            });
        }
        this.track = this.service.selectedTrack;
        this.quizQuestions = this.service.quizQuestions[this.service.selectedTrack];
        if (this.service.selectedTrack == 1) {
            this.texts = this.service.historical_1;
        }
        else if (this.service.selectedTrack == 2) {
            this.texts = this.service.historical_2;
        }
        else {
            this.texts = this.service.historical_3;
        }
        // Hämta alla svaren från frågorna
        this.db.list('/Session-' + this.service.sessionId + "/answer").valueChanges().subscribe((answers) => {
            // this.test = answers;
            for (var i of answers) {
                if (i.question == 1 && i.track == this.service.selectedTrack) {
                    if (i.answer == "ja")
                        this.question_positive_1++;
                    else
                        this.question_negative_1++;
                }
                if (i.question == 2 && i.track == this.service.selectedTrack) {
                    if (i.answer == "ja")
                        this.question_positive_2++;
                    else
                        this.question_negative_2++;
                }
                if (i.question == 3 && i.track == this.service.selectedTrack) {
                    if (i.answer == "ja")
                        this.question_positive_3++;
                    else
                        this.question_negative_3++;
                }
            }
            this.data = [
                ['JA', this.question_positive_1],
                ['NEJ', this.question_negative_1]
            ];
            this.data2 = [
                ['JA', this.question_positive_2],
                ['NEJ', this.question_negative_2]
            ];
            this.data3 = [
                ['JA', this.question_positive_3],
                ['NEJ', this.question_negative_3]
            ];
        });
        // console.log(this.data[0] = 5);
        console.log(this.data);
        // this.db.list('/Session-'+ this.service.sessionId+'/answer').valueChanges().subscribe((answers: any) => {
        // 	console.log( answers );
        // 	for(let row of answers){
        // 		// console.log(row.answer);
        // 		if (row.question == 1) {
        // 			console.log(row.answer)
        // 		}
        // 	}
        // });
    }
    goBack() {
        this.caseView = false;
    }
    openCase(event) {
        window.scroll(0, 0);
        if (event == 1) {
            this.currentTitle = this.texts.part1.title;
            this.currentText = this.texts.part1.text;
            this.currentSource = this.texts.part1.source;
            this.currentImageText = this.texts.part1.imagetext;
        }
        else if (event == 2) {
            this.currentTitle = this.texts.part2.title;
            this.currentText = this.texts.part2.text;
            this.currentSource = this.texts.part2.source;
            this.currentImageText = this.texts.part2.imagetext;
        }
        else {
            this.currentTitle = this.texts.part3.title;
            this.currentText = this.texts.part3.text;
            this.currentSource = this.texts.part3.source;
            this.currentImageText = this.texts.part3.imagetext;
        }
        this.caseView = true;
        this.case = event;
    }
    exitCases() {
        window.scroll(0, 0);
        this.exitHistorical.emit(1);
        this.db.list('/Session-' + this.service.sessionId + "/action").remove();
        this.db.list('/Session-' + this.service.sessionId + "/action").push("text");
    }
    previousQuestion() {
        this.exitHistorical.emit(0);
        this.service.currentQuestion = 3;
        this.db.list('/Session-' + this.service.sessionId + "/question").remove();
        this.db.list('/Session-' + this.service.sessionId + "/question").push("3");
        this.db.list('/Session-' + this.service.sessionId + "/action").remove();
        this.db.list('/Session-' + this.service.sessionId + "/action").push("previous");
    }
    showSourcesFunc() {
        if (this.showSources) {
            this.showSources = false;
            this.sourceArrow = "keyboard_arrow_down";
        }
        else {
            this.showSources = true;
            this.sourceArrow = "keyboard_arrow_up";
        }
    }
};
HistoricalViewComponent.ctorParameters = () => [
    { type: _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__["ApiCallerService"] },
    { type: angularfire2_database__WEBPACK_IMPORTED_MODULE_3__["AngularFireDatabase"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('window:beforeunload', ['$event'])
], HistoricalViewComponent.prototype, "beforeUnloadHander", null);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], HistoricalViewComponent.prototype, "isTeacher", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], HistoricalViewComponent.prototype, "exitHistorical", void 0);
HistoricalViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-historical-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./historical-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/historical-view/historical-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./historical-view.component.css */ "./src/app/historical-view/historical-view.component.css")).default]
    })
], HistoricalViewComponent);



/***/ }),

/***/ "./src/app/services/api-caller.service.ts":
/*!************************************************!*\
  !*** ./src/app/services/api-caller.service.ts ***!
  \************************************************/
/*! exports provided: TrackData, ApiCallerService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrackData", function() { return TrackData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApiCallerService", function() { return ApiCallerService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");



class TrackData {
}
let ApiCallerService = class ApiCallerService {
    constructor(http) {
        this.http = http;
        this.sessionCode = "";
        this.sessionId = "";
        this.selectedTrack = 0;
        this.currentQuestion = 1;
        this.myAnswers = ["", "", ""];
        this.saveCode = false;
        this.quizQuestions = {
            "1": {
                "1": "Är det bra om vi tycker lika?",
                "2": "Ska man få säga eller skriva vad man vill i media?",
                "3": "Är demokrati svårt?",
                "4": "Hur ska vi prata med varandra när vi tycker olika?"
            },
            "2": {
                "1": "Tror du att du kan göra skillnad?",
                "2": "Bör det vara enbart experter som styr Sverige?",
                "3": "Är skolan viktig för hur du ser på demokratin?",
                "4": "Hur ska vi prata med varandra när vi tycker olika?",
            },
            "3": {
                "1": "Är demokrati rättvist?",
                "2": "Innebär demokrati att alla är lika mycket värda?",
                "3": "Finns det frågor där majoriteten inte ska få bestämma?",
                "4": "Hur ska vi prata med varandra när vi tycker olika?",
            }
        };
        this.historical_1 = {
            "part1": {
                "title": 'Bokhandlare dömd för antijudisk skylt',
                "text": '<u>Bokhandlare dömd för antijudisk skylt</u><br><br>Einar Åberg måste ha varit en man med starka känslor. Särskilt när det gällde att hata judar. Han bedrev antisemitisk propaganda under större delen av sitt liv.<br><br>År 1921, när Einar Åberg var 31 år gammal, fick han tag på en skrift som kallades ”Sions vises protokoll”. Den påstods komma från en judisk konferens och ”protokollet” beskrev hur judarna ville ta över världen. Denna skrift är en viktig del i mycket av den antisemitiska propagandan både då och nu. Och hos Einar Åberg väckte skriften en livslång antisemitism.<br><br><b>Ett antijudiskt parti</b><br>Einar Åberg var en alltså aktiv antisemit redan under 1920-talet. Han deltog i många nazistiska, antisemitiska och högerextrema föreningar och partiers olika aktiviteter, men var aldrig medlem i dem.<br><br>Hösten 1941 startade han i stället ett eget parti: Sveriges antijudiska kampförbund. Första punkten i förbundets program var: ”Judendomens, i Sverige, totala förintelse”. Det var inte så många fler aktiva i partiet än Åberg själv, men han fick ändå ganska stor uppmärksamhet. Det var många som höll med Åberg på den här tiden.<br><br><b>Åtal för antijudisk skylt</b><br>På 1940-talet hyrde Einar Åberg en bokhandel på nuvarande Sergelgatan i Stockholm. I skyltfönstret hängde han en stor skylt med texten: ”Judar och halvjudar äga icke tillträde”.<br><br>Även om det fanns de som sympatiserade med nazisterna, var det också många som var emot dem.Skylten upprörde stockholmarna och det blev ofta bråk i butiken.<br><br>Einar Åberg åtalades för förargelseväckande beteende och dömdes att ta bort skylten. Då bytte han skylt till ”Endast svenskar äga tillträde”. Polisen var tvungen att flera gånger montera ner och beslagta liknande skyltar från samma fönster. Efter några månader la Åberg ner sin bokhandel.<br><br>Medan andra världskriget pågick dömdes Einar Åberg sammanlagt nio gånger till böter för förargelseväckande beteende då hans antijudiska propaganda ledde till oroligheter.<br><br><b>Efter kriget – en ny lag</b><br>Efter kriget blev Einar Åberg en av de första som ifrågasatte att det skett ett så omfattande mördade av judar, alltså det vi idag kallar för Förintelsen. Och han slutade inte med sin propaganda efter kriget – tvärtom. Einar Åberg tryckte antisemitiska flygblad och skrifter. Många av dem översattes och spreds till andra länder. Detta fick andra länder att reagera starkt mot Sverige, och var en orsak till att Sverige införde en ny lag år 1948: lagen om hets mot folkgrupp.<br><br>Einar Åberg blev också den förste som dömdes enligt lagen om hets mot folkgrupp. Därför kallas lagen ibland för Lex Åberg. Trots detta fortsatte han sin propaganda ända in på 1960-talet.',
                "source": ' <a target="_blank" href="https://www.levandehistoria.se/content/1356">Forum för levande historia</a>  <br><br> <a target="_blank" href="https://www.ne.se/uppslagsverk/encyklopedi/l%C3%A5ng/einar-%C3%A5berg">National encyklopedin</a>  <br><br><a target="_blank" href="https://skma.se/blogg/2017/06/gorel-granstrom-den-antisemitiske-bokhandlaren-och-kriminaliseringen-av-hets-mot-folkgrupp/ ">Svenska kommittén mot antisemitism</a><br><br><a target="_blank" href="https://www.bra.se/download/18.cba82f7130f475a2f1800019149/1371914731775/2001_7_hets_mot_folkgrupp.pdf ">Heléne Lööw och Lotta Nilsson, Hets mot folkgrupp. BRÅ-rapport 2001:7, Stockholm 2001, s.</a><br><br><a target="_blank" href="https://www.riksdagen.se/sv/dokument-lagar/dokument/motion/hets-och-vald-mot-homosexuella_GG02Ju834 ">Motion till riksdagen 1992/93:Ju834 av Christina Linderholm (c) angående lagen om Hets mot folkgrupp</a><br><br>',
                "imagetext": "Skyltfönstret till Åbergs bokhandel. Fotocredit: ARAB. Foto: Morgontidningen"
            },
            "part2": {
                "title": "Ministrar tvingade tidningar att vara neutrala",
                "text": '<u>Ministrar tvingade tidningar att vara neutrala</u><br/>Under andra världskriget drev den svenska regeringen att Sverige skulle vara neutralt vad gällde utrikespolitik. Och man förväntade sig att massmedierna också skulle vara neutrala.<br><br>År 1938, ett år innan kriget bröt ut, skickade Sveriges statsminister Per Albin Hansson och utrikesministern Rickard Sandler en skrivelse till många av de svenska tidningarnas chefredaktörer. I den stod bland annat: ”En viktig förutsättning för att en politik, som syftar till neutralitetens upprätthållande vid en sådan konflikt, skall kunna så friktionsfritt som möjligt genomföras, är att pressen även under en period av relativ avspänning iakttager en sådan hållning, att berättigade misstankar icke kunna riktas mot Sverige för partitagande för eller mot den ena eller andra makten eller maktgruppen.”<br><br>Med andra ord ville ministrarna säga att alla tidningar skulle skriva mycket försiktigt om vad som hände i världen, för att inte reta upp Tyskland.<br><br><b>Artiklar om tortyr ledde till ”kvarstad”</b><br/> Sveriges regering letade även fram en gammal lag som inte hade använts på hundra år. Lagen gjorde det möjligt att utan rättegång förbjuda spridning av tidningar, att beslagta tidningar och böcker, och att ”belägga dem med kvarstad”. Kvarstad betydde att staten tillfälligt kunde ta över rätten till vad personer ägde. Nu användes alltså lagen för att ta tidningar i beslag från utgivare.<br><br>I mars 1942 belades sjutton svenska tidningar med kvarstad. Tidningarna hade publicerat vittnesmål om hur den tyska ockupationsmakten torterade fångar i Norge. Ingen påstod att vittnesmålen var falska, men den svenska regeringen var orolig att artiklarna skulle uppröra ”främmande makt”, alltså Tyskland. Den som fattade beslutet om kvarstaden var Sveriges justitieminister K G Westman.<br><br>Att så många tidningar drabbades samtidigt var något nytt. Många blev upprörda. När det var debatt om kvarstaden i riksdagen, försvarade justitieminister K G Westman beslutet. Han började med att säga att regeringen uppskattade pressens oberoende, och att mediernas frihet var större i Sverige än i andra europeiska länder. Men han sa samtidigt att tryckfriheten inte fick utnyttjas för att sprida utländsk propaganda. Eftersom det som hände i Norge inte var bevisat, borde det vara förbjudet att skriva om det, för att inte sprida oro bland svenska läsare.',
                "source": 'Vallinder, T. ”Nio edsvurna män. Jury och tryckfrihet i Sverige 1815–2000. Stockholm, 2000<br><br>Riksarkivet, Utrikesdepartementet 1920 års dossiersystem I 439',
                "imagetext": "Foto: Riksarkivet Norge. Bildkälla: Wikimedia Commons"
            }
        };
        this.historical_2 = {
            "part1": {
                "title": "SS-officeren Kurt Gerstein och den svenske diplomaten Göran von Otter",
                "text": '<u>SS-officeren Kurt Gerstein och den svenske diplomaten Göran von Otter</u><br><br>Kurt Gerstein gick med i det nationalsocialistiska tyska arbetarpartiet, nazipartiet, år 1933. Men, år 1936 arresterades han för spridande av anti-nazistisk propaganda. Han fick sitta i häkte ett tag, och blev utesluten ur partiet men kunde senare bli medlem igen.<br><br>Några år senare bestämde sig Kurt Gerstein ändå för att gå med i WaffenSS. WaffenSS var en del av nazisternas militära styrkor, som man frivilligt gick med i. Men Kurt Gerstein hade en hemlig anledning. Han ville ta reda på mer om de vidriga handlingar som han hade förstått att nazisterna utförde.<br><br><b>Vittnesmål från förintelseläger år 1942</b><br/>Kurt Gerstein blev placerad i SS sanitetsavdelning, där han arbetade med hygienen bland soldater och fångar. Han blev befordrad och ansvarig för att distribuera giftgasen Zyklon B till förintelselägret Auschwitz.<br><br>I augusti 1942 befann sig Kurt Gerstein i förintelselägret Bełżec. Han blev då själv vittne till hur giftgas användes för att döda fångarna i lägret. Det fick Gerstein att må mycket dåligt.<br><br>Några veckor senare åkte Gerstein tåg från Warszawa till Berlin. På den tågresan mötte han en svensk man vid namn Göran von Otter. Göran von Otter jobbade på Sveriges utrikesdepartement, och vid den här tiden var han sekreterare på den svenska ambassaden i Berlin.<br><br>Kurt Gerstein berättade vad han hade sett i lägret för Göran von Otter. Senare samma år skrev Göran von Otter så här i ett brev:<br><br>”Han (Gerstein) skildrade därpå hela gasningsförfarandet och gav mig alla detaljer jag i kontrollsyfte begärde rörande transportförhållanden, tekniskt tillvägagångssätt, offrens, den övervakande SSpersonalens och de verkställande ukrainska arbetarnas reaktion, offrens behandling före och efter exekutionen, tillvaratagandet av smycken, guldtänder, undanstuckna valutor, begravningssätt osv. Jag fick se dokument, cyanvätebeställningar, identitetskort m.m.”<br>(Källa: Svanberg &amp; Tydén, 2005)<br><br>Med andra ord beskrev Kurt Gerstein noga hur Förintelsen pågick, mitt under kriget, för en person som arbetade på uppdrag av Sveriges regering.<br><br><b>Informationen försvann</b><br/>När Göran von Otter kom tillbaka till sin arbetsplats på ambassaden i Berlin, rapporterade han genast Gersteins information till en av sina chefer. Det bestämdes att von Otter skulle vänta med att rapportera till utrikesdepartementet tills han kom hem till Stockholm, vilket skedde i januari 1943.<br><br>Men vad som hände med informationen sedan är fortfarande oklart. Hur utrikesdepartementet reagerade på rapporten framgår inte av det källmaterial som finns.',
                "source": 'I. Svanberg & M. Tydén, ”Debatt och dokument om Europas judar 1933–1945”, Dialogos förlag (2005)',
                "imagetext": "Teckning föreställande Kurt Gerstein, konstnär okänd. Bildkälla Wikicommons"
            },
            "part2": {
                "title": 'Hemlig klubb för antinazistiskt nätverk i Sverige',
                "text": '<u>Hemlig klubb för antinazistiskt nätverk i Sverige</u><br><br>Nazityskland intog Danmark och anföll Norge tisdagen den 9 april år 1940. Samma dag höll en hemlig klubb i Stockholm sitt första möte. De kallade sig för Tisdagsklubben, och planerade att bli en svensk motståndsrörelse om Sverige blev ockuperat av Nazityskland.<br><br>Klubben fortsatte att träffas regelbundet på samma tid, veckodag och plats ända fram till krigsslutet. Nere i porten stod alltid säkerhetspolisen och antecknade deltagarnas namn. De betraktades som en säkerhetsrisk för landet då flera av medlemmarna hade kontakter med bland annat den brittiska underrättelsetjänsten.<br><br><b>Författare tog initiativet</b><br/> Den som tog initiativ till klubben var den svensk-tjeckoslovakiska författaren Amelie Posse-Brázdová. Hon hade nyligen lämnat sitt hem i Tjeckoslovakien och flyttat tillbaka till Sverige. Hon hade på nära håll upplevt hur Nazityskland tog över delar av Tjeckoslovakien och var upprörd över nazisternas agerande.<br><br>Amelie Posse-Brázdová hade lång erfarenhet av humanitärt arbete. Hon var orolig över utvecklingen i Sverige. I en bok skrev hon senare att hon ”grubblade natt och dag över vad i Herrans namn man skulle kunna ta sig till för att i tid öppna folks ögon och göra dem mera medvetna om vad som försiggick omkring dem”.<br><br><b>Judar och kommunister fick inte bli medlemmar</b><br/>Amelie Posse-Brázdová hade ett konkret syfte med Tisdagsklubben. Det var att bygga ett underjordiskt nätverk som, om Tyskland ockuperade Sverige, kunde bli kärnan i en demokratisk motståndsrörelse.<br><br>Därför var det viktigt att klubbens planer inte blev allmänt kända. Grundarna beslutade att klubbens möten skulle vara hemliga. Samtidigt fick alla ”pålitliga demokrater” bli medlemmar om de ville. Men det fanns några stora undantag.<br><br> Även om verksamheten var hemlig, var det viktigt att Tisdagsklubben framstod som en bred och demokratisk organisation. Amelie Posse-Brázdová och de andra grundarna var rädda för att klubben skulle anklagas för att vara ett verktyg för en annan stat eller för en viss politisk inriktning. Därför fick till exempel judar inte bli medlemmar. Tisdagsklubben menade att det var lättare för medlemmarna att hävda att de enbart drevs av sina samveten och sin rättskänsla, inte av personliga intressen, om de inte var judar. Man sa också att klubben ”skulle bli mera slagfärdig om vi kunde bevisa att det varken låg judiskt initiativ eller judiskt kapital bakom den. I all synnerhet som kampen mot antisemitismen just var en av de viktigaste punkterna på vårt program”.<br><br> Andra som inte var välkomna i Tisdagsklubben var kommunister och personer som var medborgare i länder utanför Skandinavien. Förbudet mot kommunister ändrades dock efter något år, när Hitler bröt sin pakt med kommunistiska Sovjet.<br><br><b>Tisdagsklubben fortsatte fram till 1945</b><br/> Tisdagsklubben blev en samlingspunkt för kända kulturpersonligheter. Bland medlemmarna fanns både de som stödde den svenska samlingsregeringen, och de som kritiserade regeringen hårt. Det alla medlemmarna i Tisdagsklubben hade gemensamt var att de var mot nazismen.<br><br>På mötena hölls det ofta föredrag och diskussioner om den politiska situationen och krigets utveckling. Klubben visade också film ibland, gärna sådana filmer som hade censurerats av de svenska myndigheterna.<br><br>Men klubben hade annan verksamhet också. Till exempel samlade medlemmarna in uppgifter om vilka som sympatiserade med nazisterna, och skickade uppgifterna till den svenska säkerhetspolisen.<br><br>En annan viktig del av Tisdagsklubbens verksamhet, som bara vissa utvalda medlemmar fick arbeta med, var att bygga upp det hemliga nätverket i landet. Planen var att ha ett system med grupper eller ”celler” i hela Sverige, som snabbt kunde aktiveras om Tyskland anföll.<br><br>Men cellerna behövde aldrig aktiveras. Tyskland förlorade kriget. Tisdagsklubben hade sitt allra sista möte den 9 april år 1945. Sedan slutade klubben med sin verksamhet – och blev för första gången offentligt presenterad i medierna.',
                "source": 'Bokholm, Sif, ”En kvinnoröst i manssamhället” (2001)',
                "imagetext": "Amelie Posse. Bildkälla: Wikicommons/Nasjonalbiblioteket"
            }
        };
        this.historical_3 = {
            "part1": {
                "title": "Rösträtten – inte riktigt för alla",
                "text": '<u>Rösträtten – inte riktigt för alla</u><br><br>Valet år 1921 var första gången som kvinnor fick rösta i Sverige. Rösträtten gällde de kvinnor som var svenska medborgare och över 23 år.<br><br>Ofta sägs det att Sverige införde allmän och lika rösträtt år 1921. Men fortfarande fanns det grupper i samhället som inte fick rösta:<br><br><ul>	<li>De som inte hade gjort sin värnplikt.</li>	<li>De som satt i häkte eller fängelse.</li>	<li>De som var beroende av fattigvården eller hade försatts i konkurs.</li>	<li>De som var omyndigförklarade.</li></ul>De här reglerna avskaffades senare och åldersgränsen för att få rösta sänktes vid flera tillfällen.<br><br><b>Kravet på genomförd värnplikt tas bort 1922</b><br/>Från 1922 behöver man inte ha påbörjat eller genomfört hela värnplikten för att få rösta. Värnplikt eller som det också heter, militärtjänst, är en skyldighet att tjänstgöra i ett lands krigsmakt. Att göra värnplikt är alltså att genomgå en militärutbildning. Fram till 1989 var det bara män som fick göra värnplikt i Sverige.<br><br><b>Dömda fick rösträtt 1937</b><br/> De svenska medborgare som satt i häkte eller i fängelse fick inte rösträtt förrän år 1937. Fram till dess hade kriminella som dömts för allvarliga brott fråntagits sin rösträtt. Man sa att de hade förlorat sitt ”medborgerliga förtroende”.<br><br>Anledningen till ändringen 1937 var att man insåg att det blev svårare för fångar att återanpassa sig till samhället, om de inte fick delta i valen.<br><br><b>De allra fattigaste fick rösträtt 1945</b><br/>Fram till 1945 hade svenska medborgare som var omhändertagna eller beroende av fattigvården inte rösträtt. Direkt efter andra världskrigets slut beslutade riksdagen att en medborgares ekonomiska situation inte skulle påverka rätten att rösta. Detta beslut påverkade även de som hade försatts i konkurs – nu fick de också rösta.<br><br><b>Vuxna som ansågs ”omyndiga” fick rösträtt 1989</b><br/>Fram till 1989 kunde personer bli omyndigförklarade. Det gällde personer med intellektuell funktionsnedsättning, demens eller psykisk störning. Det innebar att vuxna som bedömdes ”omyndiga” av en domstol inte fick ha ansvar för sin egen ekonomi. I stället fick de en så kallad god man, som skulle sköta ekonomin. Systemet med god man finns kvar i dag. Men fram till 1989 förlorade de omyndigförklarade samtidigt sin rätt att rösta.<br><br> Lagen ändrades 1989. Synen på privatpersoners rättigheter hade förändrats. Dessutom började det ses som bättre att de med olika funktionsnedsättningar anpassade sig till samhället, än att de stängdes ute.<br><br><b>Rösträtten i Sverige i dag</b><br/>Från år 1989 har alltså alla svenska medborgare över 18 år rösträtt. Och även utländska medborgare över 18 har rösträtt till kommunalvalen.<br><br> Svenska medborgare som bor utomlands har fått rösta sedan 1968 – men de fick inte rösta via brev förrän år 2002.',
                "source": '<a target="_blank" href="https://demokrati100.se/">Kungliga biblioteket Demokrati100</a><br><br><a target="_blank" href="https://www.val.se/om-oss/vart-uppdrag/rostrattens-historia.html">Valmyndigheten</a><br><br><a target="_blank" href="https://firademokratin.riksdagen.se/">Sveriges riksdag</a>',
                "imagetext": "Demonstrationståg för kvinnorösträtten, Göteborg. Bildkälla: Wikicommons/Nordiska museet"
            },
            "part2": {
                "title": 'Interneringsläger i Sverige ',
                "text": '<u>Interneringsläger i Sverige</u><br><br>Under andra världskriget skapade Sveriges regering olika typer av arbetsläger, så kallade interneringsläger. I lägren sattes personer som på olika sätt ansågs utgöra en risk för landet. De kallades för ”opålitliga element”. De olika lägren drevs av socialstyrelsens utlänningsbyrå och av försvarsmakten.<br><br><b>Flyktingar i olika läger</b><br/>I de läger som socialstyrelsen ansvarade för placerades flyktingar som kommit till Sverige. Det fanns både öppna och slutna läger. I de öppna lägren sattes de flyktingar som inte ansågs ”samhällsfarliga”, utan bara behövde hjälp.<br><br> I de slutna lägren sattes alltså de ”samhällsfarliga”. Det var flyktingar som till exempel var politiskt aktiva eller som hade deserterat ur sina hemländers arméer. Eller så var de bara så kallade disciplinfall – stökiga personer. Här kunde staten övervaka dem och hålla dem borta från samhället.<br><br><b>”Opålitliga” svenskar</b><br/>Även svenska medborgare kunde hamna i läger, om de sågs som ”nationellt opålitliga”. Det var försvarsmakten som ansvarade för de lägren. Ofta fick personerna en inkallelseorder från försvaret, och sedan sattes de i läger. Flera hundra värnpliktiga män hamnade där på det sättet.<br><br> Lägren kallades för arbetskompanier eller disciplinkompanier. De som placerades där tvingades arbeta, till exempel med att bygga vägar. Lägren fanns i hela Sverige. Ett exempel är lägret i Storsien i Norrbotten som uppfördes i december 1939.<br><br>De flesta som sattes i läger var kommunister, syndikalister, radikala socialdemokrater eller fackföreningsaktiva. Tanken var att dessa ”opålitliga element” skulle göra sin plikt under kriget, men utan vapen. Då slapp armén personer som kunde utgöra en risk, och samtidigt kunde staten hålla koll på dem.<br><br><b>Underrättelsebyrån</b><br/> Många svenskar hamnade i lägren när de blev inkallade, men inte alla. Man hämtade även folk från sina hem eller arbetsplatser utan att ens förhöra dem först.<br><br>Det var relativt lätt att veta vilka man ville sätta i läger, eftersom den så kallade underrättelsebyrån förde register över människors åsikter. Underrättelsebyrån arbetade framför allt mot antimilitarism. Många socialister var antimilitarister, alltså emot den statliga militären, och det ansågs farligt för Sverige. Militären som drev lägren menade alltså att de som sattes i läger var samhällsfarliga och kunde bli landsförrädare.<br><br><b>Efter kriget</b><br/>I slutet av andra världskriget började lägren stängas. Underrättelsebyrån skar ner sin verksamhet kraftigt efter kriget, men inte helt.<br><br> Men för många av dem som släpptes ur lägren blev livet inte som vanligt igen. De hade svårt att få jobb, eftersom de var stämplade som ”opålitliga”.',
                "source": 'Leche, H, ”Huvuddragen av de militära insatserna på säkerhetstjänstens område” (1982)<br><br>Berglund, T. & Sennerteg, N, "Svenska koncentrationsläger i Tredje rikets skugga" (2008)',
                "imagetext": "Interneringsläger, Sveg 1939-42. Bildkälla: Wikicommons/Kungliga biblioteket"
            }
        };
        this.url = 'http://adorg.se/Demokrati-app/'; // URL to web api
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
    }
    AddSession(value) {
        return this.http.get(this.url + "?newSession=" + value, this.httpOptions);
    }
    CheckCode(value) {
        return this.http.get(this.url + "?checkCode=" + value, this.httpOptions);
    }
};
ApiCallerService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
ApiCallerService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], ApiCallerService);



/***/ }),

/***/ "./src/app/student-quiz-view/student-quiz-view.component.css":
/*!*******************************************************************!*\
  !*** ./src/app/student-quiz-view/student-quiz-view.component.css ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3N0dWRlbnQtcXVpei12aWV3L3N0dWRlbnQtcXVpei12aWV3LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/student-quiz-view/student-quiz-view.component.ts":
/*!******************************************************************!*\
  !*** ./src/app/student-quiz-view/student-quiz-view.component.ts ***!
  \******************************************************************/
/*! exports provided: StudentQuizViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StudentQuizViewComponent", function() { return StudentQuizViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/api-caller.service */ "./src/app/services/api-caller.service.ts");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angularfire2/database */ "./node_modules/angularfire2/database/index.js");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(angularfire2_database__WEBPACK_IMPORTED_MODULE_3__);




let StudentQuizViewComponent = class StudentQuizViewComponent {
    constructor(service, db) {
        this.service = service;
        this.db = db;
        this.startHistorical = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.exitHistorical = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.stopStudentQuiz = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.question = "";
        this.description = "";
        this.quizOn = false;
        this.showStatus = false;
        this.currentTrack = "";
        this.finalQuestion = false;
        this.currentQuestion = 0;
    }
    beforeUnloadHander(event) {
        this.db.list('/Session-' + this.service.sessionId + "/disconnected").push("1");
    }
    answer(event) {
        this.description = "Ditt svar är registrerat. Snart kommer läraren visa vad klassen svarat.";
        this.quizOn = false;
        this.showStatus = true;
        this.service.myAnswers[this.service.currentQuestion] = event;
        this.db.list('/Session-' + this.service.sessionId + "/answer").push({ "question": this.service.currentQuestion, "answer": event, "track": this.service.selectedTrack[0] });
        this.db.list('/Session-' + this.service.sessionId + "/currentAnswer").push(1);
    }
    countDown(event) {
        if (event.action == "done") {
            this.description = "Ooops! Tiden tog slut innan du hann svara. Ingen fara, du hinner nog svara på nästa fråga istället.";
            this.quizOn = false;
            this.showStatus = true;
        }
    }
    ngOnDestroy() {
        this.actionSub.unsubscribe();
        this.questionSub.unsubscribe();
    }
    ngOnInit() {
        // Hämta track id
        this.db.list('/Session-' + this.service.sessionId + "/track").valueChanges().subscribe((track) => {
            this.currentTrack = track;
            this.service.selectedTrack = track;
            this.question = this.service.quizQuestions[this.currentTrack][this.service.currentQuestion];
        });
        this.questionSub = this.db.list('/Session-' + this.service.sessionId + "/question").valueChanges().subscribe((question) => {
            this.service.currentQuestion = question;
            this.question = this.service.quizQuestions[this.service.selectedTrack][this.service.currentQuestion];
            this.currentQuestion = question;
        });
        this.actionSub = this.db.list('/Session-' + this.service.sessionId + "/action").valueChanges().subscribe((action) => {
            if (action.length == 0) {
                return;
            }
            if (action == "reset") {
                this.stopStudentQuiz.emit();
            }
            if (action == "start") {
                this.quizOn = true;
            }
            if (action == "text") {
                this.exitHistorical.emit(1);
            }
            if (action == "historical") {
                this.service.currentQuestion++;
                this.startHistorical.emit();
            }
            if (action == "next" || action == "previous") {
                this.quizOn = false;
                this.showStatus = false;
            }
        });
        return;
    }
};
StudentQuizViewComponent.ctorParameters = () => [
    { type: _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__["ApiCallerService"] },
    { type: angularfire2_database__WEBPACK_IMPORTED_MODULE_3__["AngularFireDatabase"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], StudentQuizViewComponent.prototype, "startHistorical", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], StudentQuizViewComponent.prototype, "exitHistorical", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], StudentQuizViewComponent.prototype, "stopStudentQuiz", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('window:beforeunload', ['$event'])
], StudentQuizViewComponent.prototype, "beforeUnloadHander", null);
StudentQuizViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-student-quiz-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./student-quiz-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/student-quiz-view/student-quiz-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./student-quiz-view.component.css */ "./src/app/student-quiz-view/student-quiz-view.component.css")).default]
    })
], StudentQuizViewComponent);



/***/ }),

/***/ "./src/app/student-view/student-view.component.css":
/*!*********************************************************!*\
  !*** ./src/app/student-view/student-view.component.css ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3N0dWRlbnQtdmlldy9zdHVkZW50LXZpZXcuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/student-view/student-view.component.ts":
/*!********************************************************!*\
  !*** ./src/app/student-view/student-view.component.ts ***!
  \********************************************************/
/*! exports provided: SessionInfo, StudentViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SessionInfo", function() { return SessionInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StudentViewComponent", function() { return StudentViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/api-caller.service */ "./src/app/services/api-caller.service.ts");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angularfire2/database */ "./node_modules/angularfire2/database/index.js");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(angularfire2_database__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! firebase/app */ "./node_modules/firebase/app/dist/index.cjs.js");
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(firebase_app__WEBPACK_IMPORTED_MODULE_4__);





class SessionInfo {
}
let StudentViewComponent = class StudentViewComponent {
    constructor(service, db) {
        this.service = service;
        this.db = db;
        this.startStudentQuiz = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.title = "VÄLKOMMEN ELEV!";
        this.description = "Du ska få en kod av din lärare för att koppla upp dig till lektionen.";
        this.code = "";
        this.codeAccepted = false;
    }
    beforeUnloadHander(event) {
        this.db.list('/Session-' + this.service.sessionId + "/disconnected").push("1");
    }
    checkCode() {
        if (this.code == "") {
            return;
        }
        for (let row of this.sessions) {
            if (this.code == row) {
                this.service.myAnswers = [];
                this.service.sessionId = this.code;
                this.codeAccepted = true;
                this.title = "DU ÄR NU ANSLUTEN TILL LEKTIONEN!";
                this.description = "Håll det här fönstret i webbläsaren öppet. På den här sidan kommer du snart att få börja jobba. Din lärare styr vilken del av lektionen som ska synas här. Så håll ut, snart börjar det :)";
                this.db.list('/Session-' + this.code + "/connected").push("student");
                this.service.currentQuestion = 1;
                // Lyssnar efter att läraren aktiverar ett spår, startar läraren ett spår så startar quiz-vyn för eleven
                this.db.list('/Session-' + this.code + "/action").valueChanges().subscribe((value) => {
                    if (value.length == 0) {
                        return;
                    }
                    // if (value == "activate") {
                    this.startStudentQuiz.emit();
                    // }
                });
                firebase_app__WEBPACK_IMPORTED_MODULE_4__["analytics"]().logEvent("Student joined session");
            }
        }
    }
    OnInput(event) {
        this.code = event.target.value;
    }
    ngOnInit() {
        this.db.list('/Sessions').valueChanges().subscribe((value) => {
            this.sessions = value;
        });
    }
};
StudentViewComponent.ctorParameters = () => [
    { type: _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__["ApiCallerService"] },
    { type: angularfire2_database__WEBPACK_IMPORTED_MODULE_3__["AngularFireDatabase"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], StudentViewComponent.prototype, "startStudentQuiz", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('window:beforeunload', ['$event'])
], StudentViewComponent.prototype, "beforeUnloadHander", null);
StudentViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-student-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./student-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/student-view/student-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./student-view.component.css */ "./src/app/student-view/student-view.component.css")).default]
    })
], StudentViewComponent);



/***/ }),

/***/ "./src/app/teacher-config-view/teacher-config-view.component.css":
/*!***********************************************************************!*\
  !*** ./src/app/teacher-config-view/teacher-config-view.component.css ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/*.list{\r\n    text-align: left;\r\n}\r\n.center{\r\n\tmax-width: 400px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.right_arrow{\r\n\tposition: absolute;\r\n    top: 0;\r\n    right: 40px;\r\n    color: white;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n}\r\n\r\n.arrow_icon_right{\r\n\tposition: absolute;\r\n\tmargin-top: -3px;\r\n\tfont-size: 35px;\r\n}\r\n*/\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvdGVhY2hlci1jb25maWctdmlldy90ZWFjaGVyLWNvbmZpZy12aWV3LmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXdCQyIsImZpbGUiOiJzcmMvYXBwL3RlYWNoZXItY29uZmlnLXZpZXcvdGVhY2hlci1jb25maWctdmlldy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLyoubGlzdHtcclxuICAgIHRleHQtYWxpZ246IGxlZnQ7XHJcbn1cclxuLmNlbnRlcntcclxuXHRtYXgtd2lkdGg6IDQwMHB4O1xyXG4gICAgbWFyZ2luLWxlZnQ6IGF1dG87XHJcbiAgICBtYXJnaW4tcmlnaHQ6IGF1dG87XHJcbn1cclxuXHJcbi5yaWdodF9hcnJvd3tcclxuXHRwb3NpdGlvbjogYWJzb2x1dGU7XHJcbiAgICB0b3A6IDA7XHJcbiAgICByaWdodDogNDBweDtcclxuICAgIGNvbG9yOiB3aGl0ZTtcclxuICAgIGZvbnQtc2l6ZTogMjBweDtcclxuICAgIGZvbnQtd2VpZ2h0OiA3MDA7XHJcbiAgICBjdXJzb3I6IHBvaW50ZXI7XHJcbn1cclxuXHJcbi5hcnJvd19pY29uX3JpZ2h0e1xyXG5cdHBvc2l0aW9uOiBhYnNvbHV0ZTtcclxuXHRtYXJnaW4tdG9wOiAtM3B4O1xyXG5cdGZvbnQtc2l6ZTogMzVweDtcclxufVxyXG4qLyJdfQ== */");

/***/ }),

/***/ "./src/app/teacher-config-view/teacher-config-view.component.ts":
/*!**********************************************************************!*\
  !*** ./src/app/teacher-config-view/teacher-config-view.component.ts ***!
  \**********************************************************************/
/*! exports provided: SessionInfo, TeacherConfigViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SessionInfo", function() { return SessionInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TeacherConfigViewComponent", function() { return TeacherConfigViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/api-caller.service */ "./src/app/services/api-caller.service.ts");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angularfire2/database */ "./node_modules/angularfire2/database/index.js");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(angularfire2_database__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! firebase/app */ "./node_modules/firebase/app/dist/index.cjs.js");
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(firebase_app__WEBPACK_IMPORTED_MODULE_4__);





class SessionInfo {
}
let TeacherConfigViewComponent = class TeacherConfigViewComponent {
    constructor(service, db) {
        this.service = service;
        this.db = db;
        // @Output() saveSession = new EventEmitter();
        this.setTrack = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.oldCode = false;
        this.codePath = false;
        this.usedCode = false;
        this.title = "VÄLKOMMEN LÄRARE!";
        this.description = "Skapa en kod för att koppla ihop dina elever och dig i en lektion.";
        this.code = ""; // Den valda koden
        this.codeSelected = false; // Visar spår när man valt kod
        this.sessionCode = ""; // Visar koden i botten på sidan
        this.connected = 0;
        this.totalConnects = 0;
        this.totalDisConnects = 0;
    }
    onSearchChange(event) {
        this.code = event;
    }
    selectedCodePath(event) {
        this.codePath = true;
        if (event == 1)
            this.usedCode = false;
        else
            this.usedCode = true;
    }
    // Läraren sparar en kod som skickas till DB
    AcceptCode(event) {
        this.usedCode = false;
        if (event == 1) {
            for (let row of this.sessions) {
                if (this.code == row) {
                    this.codeSelected = true;
                    this.service.sessionCode = this.code;
                    this.service.sessionId = this.code;
                    this.sessionCode = this.code;
                    this.db.list('/Session-' + this.service.sessionId + "/action").remove();
                    this.db.list('/Session-' + this.service.sessionId + "/question").remove();
                    this.db.list('/Session-' + this.service.sessionId + "/track").remove();
                    this.db.list('/Session-' + this.service.sessionId + "/connected").remove();
                    this.db.list('/Session-' + this.service.sessionId + "/disconnected").remove();
                }
                ;
            }
        }
        else {
            this.service.sessionCode = this.code;
            this.service.sessionId = this.code;
            this.sessionCode = this.code;
            this.codeSelected = true;
            this.db.list('/Sessions').push(this.code);
            this.db.list('Session-' + this.code + "/code").push(this.code);
            this.title = "VÄLJ TEMA";
        }
        //Läser av hur många som är kopplade till sessionen
        this.db.list('/Session-' + this.code + "/connected").valueChanges().subscribe((session) => {
            this.session = session;
            this.totalConnects = session.length;
            this.calculateConnects();
        });
        this.db.list('/Session-' + this.service.sessionCode + "/disconnected").valueChanges().subscribe((disconnects) => {
            this.totalDisConnects = disconnects.length;
            this.calculateConnects();
        });
    }
    calculateConnects() {
        this.connected = this.totalConnects - this.totalDisConnects;
    }
    //När läraren väljer ett av de tre spåren
    SelectTrack(trackId) {
        firebase_app__WEBPACK_IMPORTED_MODULE_4__["analytics"]().logEvent("Teacher started session", {
            track: trackId
        });
        if (this.service.saveCode) {
            this.code = this.service.sessionCode;
            this.db.list('/Session-' + this.service.sessionId + "/action").remove();
            this.db.list('/Session-' + this.service.sessionId + "/question").remove();
            this.db.list('/Session-' + this.service.sessionId + "/track").remove();
            this.db.list('/Session-' + this.service.sessionId + "/connected").remove();
            this.db.list('/Session-' + this.service.sessionId + "/disconnected").remove();
        }
        //Meddela att läraren är klar med inställningar så vi kan gå vidare till nästa vy
        this.setTrack.emit(event);
        //Spara spår och sätt fråga till nummer 1
        this.service.selectedTrack = trackId;
        this.service.currentQuestion = 1;
        //Spara spår och fråga i FB
        this.db.list('/Session-' + this.code + "/track").push(trackId);
        this.db.list('/Session-' + this.code + "/action").push("activate");
        this.db.list('/Session-' + this.code + "/question").push("1");
    }
    ngOnInit() {
        if (this.service.saveCode) {
            this.codeSelected = true;
            this.db.list('/Session-' + this.service.sessionId + "/connected").remove();
        }
        this.db.list('/Sessions').valueChanges().subscribe((value) => {
            this.sessions = value;
        });
        var exists = false;
        this.code = Math.floor(Math.random() * 9 + 1) + "" + Math.floor(Math.random() * 9 + 1) + "" + Math.floor(Math.random() * 9 + 1) + "" + Math.floor(Math.random() * 9 + 1) + "" + Math.floor(Math.random() * 9 + 1) + "" + Math.floor(Math.random() * 9 + 1);
        this.sessionCode = this.code;
        this.db.list('/Sessions').valueChanges().subscribe((value) => {
            for (let row of value) {
                if (row == this.code) {
                    exists = true;
                }
            }
        });
    }
};
TeacherConfigViewComponent.ctorParameters = () => [
    { type: _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__["ApiCallerService"] },
    { type: angularfire2_database__WEBPACK_IMPORTED_MODULE_3__["AngularFireDatabase"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], TeacherConfigViewComponent.prototype, "setTrack", void 0);
TeacherConfigViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-teacher-config-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./teacher-config-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/teacher-config-view/teacher-config-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./teacher-config-view.component.css */ "./src/app/teacher-config-view/teacher-config-view.component.css")).default]
    })
], TeacherConfigViewComponent);



/***/ }),

/***/ "./src/app/teacher-quiz-view/teacher-quiz-view.component.css":
/*!*******************************************************************!*\
  !*** ./src/app/teacher-quiz-view/teacher-quiz-view.component.css ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3RlYWNoZXItcXVpei12aWV3L3RlYWNoZXItcXVpei12aWV3LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/teacher-quiz-view/teacher-quiz-view.component.ts":
/*!******************************************************************!*\
  !*** ./src/app/teacher-quiz-view/teacher-quiz-view.component.ts ***!
  \******************************************************************/
/*! exports provided: TeacherQuizViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TeacherQuizViewComponent", function() { return TeacherQuizViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/api-caller.service */ "./src/app/services/api-caller.service.ts");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angularfire2/database */ "./node_modules/angularfire2/database/index.js");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(angularfire2_database__WEBPACK_IMPORTED_MODULE_3__);




let TeacherQuizViewComponent = class TeacherQuizViewComponent {
    constructor(service, db) {
        this.service = service;
        this.db = db;
        this.startHistorical = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.resetAll = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.previous_arrow_text = "Tillbaka till förra frågan";
        this.next_arrow_text = "Vidare till nästa fråga";
        this.next_text = "Till nästa fråga";
        this.positive = 0;
        this.negative = 0;
        this.currentTrack = 0;
        this.currentQuestion = 0;
        this.quizOn = false;
        this.timesUp = false;
        this.showResult = false;
        this.finalQuestion = false;
        this.counter2 = 25;
        this.question = "";
        this.description = "";
        this.type = 'PieChart';
        this.data = [
            ['JA', 1],
            ['NEJ', 2]
        ];
        this.options = {
            id: "chart",
            colors: ['#6CAEDF', '#4FB847'],
            height: 600,
            width: 600,
            backgroundColor: "transparent",
            legend: 'none',
            pieSliceText: 'label',
            tooltip: { textStyle: { fontSize: 14, bold: true } }
        };
        this.options2 = {
            id: "chart",
            colors: ['#6CAEDF', '#7372A9'],
            height: 600,
            width: 600,
            backgroundColor: "transparent",
            legend: 'none',
            pieSliceText: 'label',
            tooltip: { textStyle: { fontSize: 14, bold: true } }
        };
        this.options3 = {
            id: "chart",
            colors: ['#EF4E91', '#F78F1E'],
            height: 600,
            width: 600,
            backgroundColor: "transparent",
            legend: 'none',
            pieSliceText: 'label',
            tooltip: { textStyle: { fontSize: 14, bold: true } }
        };
    }
    beforeUnloadHander(event) {
        this.db.list('/Session-' + this.service.sessionId + "/action").remove();
        this.db.list('/Session-' + this.service.sessionId + "/action").push("reset");
    }
    /*
        Läraren klickar på "Nästa fråga"
        Skickar notis till firebase med nuvarande frågeindex
    */
    startQuestion(event) {
        this.quizOn = true;
        // När man startar en fråga så rensar man i "action" och sätter start
        this.db.list('/Session-' + this.service.sessionId + "/action").remove();
        this.db.list('/Session-' + this.service.sessionId + "/action").push("start");
    }
    /*
        Vad som händer när countern når 0
    */
    countDown(event) {
        if (event.action == "done") {
            this.timesUp = true;
        }
    }
    /*
        När läraren klickar på "Visa klassens svar"
    */
    presentResult() {
        this.showResult = true;
        this.timesUp = false;
        //Läser in alla svaren så det kan presenteras för läraren
        //läses in varje gång en elev klickar på ett svar så läraren blir bombad med anrop, temporär fix som rensar svaren för varje gång
        this.db.list('/Session-' + this.service.sessionId + "/answer").valueChanges().subscribe((answers) => {
            this.negative = 0;
            this.positive = 0;
            for (let row of answers) {
                if (row.question == this.service.currentQuestion) {
                    if (row.answer == "ja") {
                        this.positive++;
                    }
                    else {
                        this.negative++;
                    }
                }
            }
            this.data = [
                ['JA', this.positive],
                ['NEJ', this.negative]
            ];
        });
    }
    chooseTheme() {
    }
    previousQuestion() {
        this.db.list('/Session-' + this.service.sessionId + "/currentAnswer").remove();
        this.finalQuestion = false;
        if (this.service.currentQuestion == 4) {
            // this.service.currentQuestion--;
            this.next_arrow_text = "Vidare till historiska case";
            this.db.list('/Session-' + this.service.sessionId + "/action").remove();
            this.db.list('/Session-' + this.service.sessionId + "/action").push("historical");
            this.db.list('/Session-' + this.service.sessionId + "/question").remove();
            this.db.list('/Session-' + this.service.sessionId + "/question").push(this.service.currentQuestion);
            this.startHistorical.emit();
            return;
        }
        if (this.service.currentQuestion == 5) {
            this.service.currentQuestion--;
            this.db.list('/Session-' + this.service.sessionId + "/action").remove();
            this.db.list('/Session-' + this.service.sessionId + "/action").push("previous");
            this.db.list('/Session-' + this.service.sessionId + "/question").remove();
            this.db.list('/Session-' + this.service.sessionId + "/question").push(this.service.currentQuestion);
        }
        else {
            this.service.currentQuestion--;
            this.next_arrow_text = "Vidare till nästa fråga";
            this.currentQuestion = this.service.currentQuestion;
            this.db.list('/Session-' + this.service.sessionId + "/action").remove();
            this.db.list('/Session-' + this.service.sessionId + "/action").push("previous");
            this.db.list('/Session-' + this.service.sessionId + "/question").remove();
            this.db.list('/Session-' + this.service.sessionId + "/question").push(this.service.currentQuestion);
        }
        if (this.service.currentQuestion == 4) {
            this.previous_arrow_text = "Tillbaka till historiska case";
        }
        this.quizOn = false;
        this.showResult = false;
        this.timesUp = false;
        this.question = this.service.quizQuestions[this.service.selectedTrack][this.service.currentQuestion];
        this.description = this.service.quizQuestions[this.service.selectedTrack]["5"];
    }
    nextQuestion() {
        this.db.list('/Session-' + this.service.sessionId + "/currentAnswer").remove();
        // Om man är på fråga 3 så ska texter bytas i knapp och toplänk då det är historiska case som är nästa vy
        if (this.service.currentQuestion == 3) {
            this.service.currentQuestion++;
            this.next_arrow_text = "Vidare till historiska case";
            this.db.list('/Session-' + this.service.sessionId + "/action").remove();
            this.db.list('/Session-' + this.service.sessionId + "/action").push("historical");
            this.db.list('/Session-' + this.service.sessionId + "/question").remove();
            this.db.list('/Session-' + this.service.sessionId + "/question").push(this.service.currentQuestion);
            this.startHistorical.emit();
            return;
        }
        // Öka med 1 varje gång man klickar på visa nästa fråga
        this.service.currentQuestion++;
        this.currentQuestion = this.service.currentQuestion;
        this.db.list('/Session-' + this.service.sessionId + "/question").remove();
        this.db.list('/Session-' + this.service.sessionId + "/question").push(this.service.currentQuestion);
        this.db.list('/Session-' + this.service.sessionId + "/action").remove();
        this.db.list('/Session-' + this.service.sessionId + "/action").push("next");
        this.quizOn = false;
        this.showResult = false;
        this.timesUp = false;
        this.question = this.service.quizQuestions[this.service.selectedTrack][this.service.currentQuestion];
        this.description = this.service.quizQuestions[this.service.selectedTrack]["5"];
        if (this.service.currentQuestion == 3) {
            this.next_text = "Till historiska case";
            this.next_arrow_text = "Vidare till historiska case";
        }
        // På fråga fem ska utseendet ändras
        if (this.service.currentQuestion == 5) {
            this.finalQuestion = true;
            this.currentQuestion = this.service.currentQuestion;
            this.currentTrack = this.service.selectedTrack;
            this.previous_arrow_text = "Tillbaka till förra frågan";
        }
    }
    reset() {
        this.db.list('/Session-' + this.service.sessionId + "/action").remove();
        this.db.list('/Session-' + this.service.sessionId + "/action").push("reset");
        this.resetAll.emit();
    }
    /*
        När vyn först presenteras så ska den första frågan presenteras
    */
    ngOnInit() {
        this.currentQuestion = this.service.currentQuestion;
        if (this.service.currentQuestion == 3) {
            this.next_arrow_text = "Vidare till historiska case";
        }
        if (this.service.currentQuestion == 4) {
            this.next_arrow_text = "Till avslut";
            this.next_text = "Till avslut";
            this.previous_arrow_text = "Tillbaka till historiska case";
        }
        this.question = this.service.quizQuestions[this.service.selectedTrack][this.service.currentQuestion];
    }
};
TeacherQuizViewComponent.ctorParameters = () => [
    { type: _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__["ApiCallerService"] },
    { type: angularfire2_database__WEBPACK_IMPORTED_MODULE_3__["AngularFireDatabase"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], TeacherQuizViewComponent.prototype, "startHistorical", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], TeacherQuizViewComponent.prototype, "resetAll", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('window:beforeunload', ['$event'])
], TeacherQuizViewComponent.prototype, "beforeUnloadHander", null);
TeacherQuizViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-teacher-quiz-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./teacher-quiz-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/teacher-quiz-view/teacher-quiz-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./teacher-quiz-view.component.css */ "./src/app/teacher-quiz-view/teacher-quiz-view.component.css")).default]
    })
], TeacherQuizViewComponent);



/***/ }),

/***/ "./src/app/text-view/text-view.component.css":
/*!***************************************************!*\
  !*** ./src/app/text-view/text-view.component.css ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3RleHQtdmlldy90ZXh0LXZpZXcuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/text-view/text-view.component.ts":
/*!**************************************************!*\
  !*** ./src/app/text-view/text-view.component.ts ***!
  \**************************************************/
/*! exports provided: TextViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextViewComponent", function() { return TextViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/api-caller.service */ "./src/app/services/api-caller.service.ts");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angularfire2/database */ "./node_modules/angularfire2/database/index.js");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(angularfire2_database__WEBPACK_IMPORTED_MODULE_3__);




let TextViewComponent = class TextViewComponent {
    constructor(service, db) {
        this.service = service;
        this.db = db;
        this.exitLast = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.resetAll = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.stopStudentQuiz = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.startHistorical = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.totalChars = 0;
        this.teacher = true;
        this.showView = false;
        this.answered = false;
        this.answer = "";
        this.counter = 0;
        this.question = "";
        this.description = "";
    }
    whatUser(user) {
        if (user) {
            this.teacher = true;
            this.showView = true;
        }
        else {
            this.teacher = false;
            this.showView = true;
        }
    }
    reset() {
        this.db.list('/Session-' + this.service.sessionId + "/action").remove();
        this.db.list('/Session-' + this.service.sessionId + "/action").push("reset");
        this.resetAll.emit();
    }
    OnInput(value) {
        this.answer = value.target.value;
        this.totalChars = this.answer.length;
    }
    sendAnswer() {
        if (this.answer == "") {
            return;
        }
        this.db.list('/Session-' + this.service.sessionId + "/textAnswer").push({
            "answer": this.answer,
            "track": this.service.selectedTrack
        });
        this.answered = true;
    }
    previousQuestion() {
        this.exitLast.emit();
        this.db.list('/Session-' + this.service.sessionId + "/action").remove();
        this.db.list('/Session-' + this.service.sessionId + "/action").push("historical");
    }
    ngOnInit() {
        // this.service.selectedTrack = 1;
        // this.service.sessionId = 669343;
        this.db.list('/Session-' + this.service.sessionId + "/textAnswer").valueChanges().subscribe((answer) => {
            this.allAnswers = answer;
            this.allAnswers.reverse();
        });
        this.question = this.service.quizQuestions[this.service.selectedTrack][4];
        this.actionSub = this.db.list('/Session-' + this.service.sessionId + "/action").valueChanges().subscribe((action) => {
            if (action.length == 0) {
                return;
            }
            if (action == "reset") {
                this.stopStudentQuiz.emit();
            }
            if (action == "historical") {
                this.service.currentQuestion--;
                this.startHistorical.emit();
            }
        });
    }
    getColor(i) {
        return "block" + i % 5;
    }
    ngOnDestroy() {
        this.actionSub.unsubscribe();
    }
};
TextViewComponent.ctorParameters = () => [
    { type: _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__["ApiCallerService"] },
    { type: angularfire2_database__WEBPACK_IMPORTED_MODULE_3__["AngularFireDatabase"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], TextViewComponent.prototype, "isTeacher", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], TextViewComponent.prototype, "exitLast", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], TextViewComponent.prototype, "resetAll", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], TextViewComponent.prototype, "stopStudentQuiz", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], TextViewComponent.prototype, "startHistorical", void 0);
TextViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-text-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./text-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/text-view/text-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./text-view.component.css */ "./src/app/text-view/text-view.component.css")).default]
    })
], TextViewComponent);



/***/ }),

/***/ "./src/app/top-info-block/top-info-block.component.css":
/*!*************************************************************!*\
  !*** ./src/app/top-info-block/top-info-block.component.css ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3RvcC1pbmZvLWJsb2NrL3RvcC1pbmZvLWJsb2NrLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/top-info-block/top-info-block.component.ts":
/*!************************************************************!*\
  !*** ./src/app/top-info-block/top-info-block.component.ts ***!
  \************************************************************/
/*! exports provided: TopInfoBlockComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TopInfoBlockComponent", function() { return TopInfoBlockComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/api-caller.service */ "./src/app/services/api-caller.service.ts");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angularfire2/database */ "./node_modules/angularfire2/database/index.js");
/* harmony import */ var angularfire2_database__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(angularfire2_database__WEBPACK_IMPORTED_MODULE_3__);




let TopInfoBlockComponent = 
// @Pipe({ name: 'reverse' })
// export class ReversePipe implements PipeTransform {
//   transform(value) {
//     return value.slice().reverse();
//   }
// }
class TopInfoBlockComponent {
    // getColor(i){
    //   let test = false;
    //   for (let entry of this.foo) {
    //     if (entry == i) {
    //       true;
    //       return;
    //     }
    //   }
    //   if (!test){
    //     console.log("value "+ i);
    //     this.foo.push(i);
    //   console.log(this.foo);
    //   var value = this.counter;
    //   this.counter++;
    //   if (this.counter == 5)
    //     this.counter = 0;
    //   return "block"+value;
    //   }
    // }
    // getColor(i){
    //   return "block"+ i%5;
    // }
    constructor(service, db) {
        this.service = service;
        this.db = db;
        this.selectedUser = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.counter = 0;
    }
    userChoice(event) {
        this.selectedUser.emit(event);
    }
    ngOnInit() {
        // this.service.selectedTrack = 1;
        // this.service.sessionId = "669343";
        this.db.list('/Session-' + this.service.sessionId + "/textAnswer").valueChanges().subscribe((answer) => {
            this.allAnswers = answer;
            this.allAnswers.reverse();
        });
    }
};
TopInfoBlockComponent.ctorParameters = () => [
    { type: _services_api_caller_service__WEBPACK_IMPORTED_MODULE_2__["ApiCallerService"] },
    { type: angularfire2_database__WEBPACK_IMPORTED_MODULE_3__["AngularFireDatabase"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], TopInfoBlockComponent.prototype, "selectedUser", void 0);
TopInfoBlockComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-top-info-block',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./top-info-block.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/top-info-block/top-info-block.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./top-info-block.component.css */ "./src/app/top-info-block/top-info-block.component.css")).default]
    })
    // @Pipe({ name: 'reverse' })
    // export class ReversePipe implements PipeTransform {
    //   transform(value) {
    //     return value.slice().reverse();
    //   }
    // }
], TopInfoBlockComponent);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   firebase : {
//     apiKey: "AIzaSyA39uo6ohwCxP8OJc1jfdGITuLDdKCETOE",
//     authDomain: "demokrati-a63f7.firebaseapp.com",
//     databaseURL: "https://demokrati-a63f7.firebaseio.com",
//     projectId: "demokrati-a63f7",
//     storageBucket: "demokrati-a63f7.appspot.com",
//     messagingSenderId: "27798996976",
//     appId: "1:27798996976:web:6448efd1ad06d9b332bf35",
//     measurementId: "G-GCQYG966Y7"
//   }
// };
const environment = {
    production: false,
    firebase: {
        apiKey: "AIzaSyBh8WvzqbIlm2oW0DjtwptyIKb2XUXb8OY",
        authDomain: "demokrati-5d660.firebaseapp.com",
        databaseURL: "https://demokrati-5d660.firebaseio.com",
        projectId: "demokrati-5d660",
        storageBucket: "demokrati-5d660.appspot.com",
        messagingSenderId: "380992125300",
        appId: "1:380992125300:web:a8f6b8db7423ed455cd421",
        measurementId: "G-8983YVPSLK"
    }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");






if (_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_4__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/alexanderbrodin/Documents/Demokrati-app/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map